export default {
  jointCalc: {
    member: '構件材料',
    manualMember: '手動構件材料',
    recordedStress: '已記錄的名義軸向應力 (MPa)',
    comparisonHint:
      '僅限相同緊固件、階段及應力面積比較。此為一致性比較，非物理驗證。',
    title: '緊固件與構件手算',
    limit:
      '單一緊固件載荷路徑的名義估計。不驗證疲勞、螺紋滑牙、撬力、塑性或破裂。不可將名義應力與局部 FEA 峰值比較。',
    fastener: '緊固件',
    manual: '手動載荷路徑',
    stage: '載荷階段',
    assembly: '組裝',
    service: '工作載荷',
    path: '載荷傳遞路徑',
    pathHint: '例如：板件 A → 螺栓 1 → 板件 B；在下方輸入載荷與截面假設',
    reset: '重設假設',
    resetTooltip: '還原所有由執行結果與材料庫帶入的數值。',
    provenance:
      '截面積分力、已記錄的應力面積及所選材料降伏強度用作初值。目標與舊版實體平均值不當作量測力。其他輸入皆為明示假設；面板開啟期間，編輯值保留於此 DP、緊固件與階段。',
    inputs: {
      fastenerYield: '緊固件材料降伏強度，非保證強度',
      memberYield: '構件材料降伏強度',
      axial: '緊固件軸向力',
      shear: '此緊固件承受的剪力',
      memberLoad: '通過構件淨截面的載荷',
      area: '軸向應力面積',
      shearArea: '有效總剪切面積',
      diameter: '桿部承壓直徑',
      thickness: '構件厚度',
      netWidth: '所選失效路徑的淨寬度',
      ligament: '孔邊到自由邊的淨韌帶長度',
      eccentricity: '有效彎曲力臂',
      modulus: '彎曲軸的彈性截面模數',
      preload: '已量測的組裝預載',
      tension: '每個緊固件的外部拉開力',
      fraction: '接頭載荷比例 C = kb / (kb + km)，0 ≤ C < 1',
      friction: '摩擦係數',
    },
    relations: {
      axialYield: '僅軸向降伏係數',
      netYield: '淨截面降伏係數',
      axial: '名義軸向應力',
      shear: '緊固件名義剪應力',
      bearing: '構件承壓應力',
      net: '淨截面拉應力',
      tear: '剪切撕裂',
      bending: '名義彎曲估計',
      separation: '預測分離載荷',
      clamp: '剩餘夾緊力',
      slip: '摩擦滑移閾值',
    },
    notes: {
      axialYield:
        '僅均勻軸向降伏。不涵蓋組合載荷、螺紋、彎曲、保證強度或疲勞。零應力無有限係數。',
      netYield:
        '僅名義淨截面降伏。不涵蓋承壓、撕裂、塊狀剪切或破裂。零應力無有限係數。',
      axial: '假設輸入面積上軸向應力均勻；力的正負號見求解結果表。',
      shear: '使用實際總剪切面積，考慮剪切平面數及螺紋是否通過平面。',
      bearing: '單一構件的投影承壓面積 d × t；非局部接觸壓力峰值。',
      net: '輸入實際孔排列的最小淨寬度，必要時包含交錯孔修正。',
      tear: '假設到自由邊有兩條相同剪切韌帶。非塊狀剪切或破裂準則。',
      bending:
        '使用者定義力矩 V × e 與彈性截面模數。非已驗證的螺栓或鉚釘彎曲模型。',
      separation:
        '固定組裝預載的線性雙彈簧同軸拉伸模型。不包含撬力與預載鬆弛。',
      clamp: '單一路徑；拉力卸除構件夾力直到零。不預測熱鬆弛。',
      slip: '每個路徑一個摩擦介面。使用剩餘夾力而非螺栓力。不以猜測的緊固件數量相乘。',
    },
  },
  assemblyEval: {
    unavailable: '無可用資料',
    yes: '是',
    no: '否',
    unmeasured: '此運算已宣告，但未記錄量測結果。',
    verification: '已記錄的求解器驗證',
    unchecked: '未檢查',
    rule: '規則版本',
    groups: {
      body_stresses: '實體應力',
      bolt_preloads: '熱預載：組裝與服役',
      pretension_forces: '最終預拉截面力',
      contact_pairs: '最終接觸狀態',
    },
    hints: {
      body_stresses: '各區域使用自身材料。共用介面節點可能計入多個區域。',
      bolt_preloads: '目標值是輸入。組裝預載與服役力為不同量測；缺值不代表零。',
      pretension_forces:
        '由最終步驟截面應力積分得到的帶正負號法向力；正值代表拉力。',
      contact_pairs: '幾何開口與壓力是獨立量測。缺少壓力不代表接頭閉合。',
    },
    fields: {
      volume_id: '區域',
      material_name: '材料',
      max_von_mises_MPa: '最大 von Mises 應力 (MPa)',
      max_principal_MPa: '最大主應力 σ1 (MPa)',
      min_principal_MPa: '最小主應力 σ3 (MPa)',
      max_shear_MPa: '最大剪應力 (MPa)',
      max_displacement_mm: '最大位移 (mm)',
      safety_factor_yield: '降伏安全係數',
      assessment: '評估',
      shared_node_count: '共用節點',
      name: '名稱',
      target_force_n: '目標 (N)',
      achieved_force_n: '組裝預載 (N)',
      service_force_n: '服役力 (N)',
      stress_MPa: '組裝應力 (MPa)',
      service_stress_MPa: '服役應力 (MPa)',
      grade: '強度等級',
      proof_load_n: '保證荷重 (N)',
      margin_n: '餘裕 (N)',
      verdict: '判定',
      force_source: '力的來源',
      calibrated: '已校準',
      delta_t_k: '溫度變化 (K)',
      surface: '截面',
      normal_force_n: '最終法向力 (N)',
      source: '來源',
      dependent_surface: '從屬表面',
      transmitted_force_n: '傳遞力 (N)',
      max_pressure_MPa: '最大壓力 (MPa)',
      pressure_source: '壓力來源',
      max_separation_mm: '最大間隙 (mm)',
      separation_tolerance_mm: '開口容許值 (mm)',
      opened: '已開口',
      preloaded: '有預載',
    },
    sources: {
      PASS: '通過',
      WARNING: '警告',
      FAIL: '失敗',
      USABLE: '可使用',
      FAILED: '失敗',
      NOT_CONVERGED: '未收斂',
      SETUP_WRONG: '設定錯誤',
      converged: '已收斂',
      oscillating: '振盪',
      drifting: '漂移',
      unsteady: '非穩態',
      not_measurable: '無法量測',
      not_applicable: '不適用',
      could_not_check: '無法檢查',
      ok: '在保證荷重內',
      over_proof: '超過保證荷重',
      section_stress_integral: '截面應力積分',
      section_stress_integration: '截面應力積分',
      unavailable: '無可用資料',
      legacy_body_mean: '舊版實體平均估計',
      final_contact: '最終接觸輸出',
      legacy_contact: '舊版接觸輸出',
    },
    askAssistantAgent: 'Agent',
    askAssistant: '詢問此組裝一覽',
    askAssistantLabel: '請助理說明這些 FEA 組裝量測與已記錄的驗證',
    askAssistantTitle: 'FEA 組裝 · 驗證',
    askAssistantNoGroups: '此頁沒有顯示組裝量測群組。',
    askAssistantGroupEmpty: '- {{group}}：已宣告但未量測。',
    askAssistantGroup: '- {{group}}：\n{{rows}}',
    askAssistantRow: '  列 {{index}}：{{cells}}',
    askAssistantVerification:
      '已記錄驗證：判定 {{verdict}}、收斂 {{convergence}}。理由：{{reason}}。未檢查：{{unchecked}}。規則 {{rule}}。',
    askAssistantVerificationAbsent: '此設計點沒有附帶已記錄的求解器驗證。',
    askAssistantNoReason: '未提供',
    askAssistantNoUnchecked: '無',
    askAssistantPrompt:
      '請說明此頁的 FEA 組裝一覽。\n\n{{groups}}\n\n{{verificationBlock}}\n\n這些量測對這次執行代表什麼——哪些接頭看起來張開或過載、驗證是否可信、下一步該查什麼？請用白話回答；不要使用工具名稱或配線欄位名稱。\n\n{{toolContext}}',
    askAssistantToolContext:
      '僅供工具的脈絡——不要向我重複：study {{studyId}}, design point {{dpId}}, attempt {{attemptId}}。',
  },
  feaThermal: {
    askHeatBalanceAgent: 'Agent',
    askHeatBalance: '詢問熱與能量平衡',
    askHeatBalanceLabel: '請助理說明此 FEA 熱／能量平衡與面加熱／冷卻率',
    askHeatBalanceTitle: 'FEA 熱平衡',
    askHeatBalanceStatusPass: '通過',
    askHeatBalanceStatusFail: '未通過',
    askHeatBalanceStatusUnavailable: '未量測',
    askHeatBalanceStatusNone: '未回報',
    askHeatBalanceNoFaces: '沒有列出邊界面熱流率。',
    askHeatBalanceFaceHeating: '加熱',
    askHeatBalanceFaceCooling: '冷卻',
    askHeatBalanceFaceNeutral: '中性',
    askHeatBalanceFaceLine: '- {{face}}（{{role}}）：{{watts}}',
    askHeatBalanceCoarseFace: '可能過粗的 BC 面：{{face}}。',
    askHeatBalanceNoCoarseFace: '未指名過粗的 BC 面。',
    askHeatBalanceHeatBlock:
      '邊界通量解析度：{{status}}。進熱 {{heatIn}}、出熱 {{heatOut}}、不平衡 {{imbalance}}（容差 {{tolerance}}）。{{coarse}}\n面熱流率（正值加熱固體）：\n{{faces}}',
    askHeatBalanceHeatAbsent: '此執行未評定邊界通量解析度。',
    askHeatBalanceEnergyBlock:
      '時段能量守恆：{{status}}。輸入能量 {{energyIn}}、輸出能量 {{energyOut}}、儲能變化 {{stored}}、不平衡 {{imbalance}}。',
    askHeatBalanceEnergyAbsent: '此執行未評定積分能量守恆。',
    askHeatBalancePrompt:
      '請說明此頁的 FEA 熱／能量平衡。\n\n{{heatBlock}}\n\n{{energyBlock}}\n\n說明正負號慣例：正的面瓦特加熱固體（紅）；負值冷卻（藍）。說明 BC 面網格是否過粗、暫態能量簿記是否閉合、以及下一步該查什麼。請用白話回答；不要使用工具名稱或配線欄位名稱。\n\n{{toolContext}}',
    askHeatBalanceToolContext:
      '僅供工具的脈絡——不要向我重複：study {{studyId}}, design point {{dpId}}, attempt {{attemptId}}。',
    askFluxResolution: '詢問邊界熱流解析度',
    askFluxResolutionLabel:
      '請助理說明邊界面積分為何不一致，以及 BC 面網格是否過粗',
    askFluxResolutionTitle: '邊界熱流解析度',
    askFluxResolutionPrompt:
      '請說明此 FEA 邊界熱流解析度檢查。\n\n{{heatBlock}}\n\n請聚焦 BC 面的面積分與網格厚度（積分不一致＋網格過粗）。說明正負號慣例：正的面瓦特加熱固體。說明下一步應重劃網格或複查什麼。請用白話回答；不要使用工具名稱或配線欄位名稱。\n\n{{toolContext}}',
    askEnergyClosure: '詢問能量守恆',
    askEnergyClosureLabel: '請助理說明為何時段積分能量簿記未閉合',
    askEnergyClosureTitle: '能量守恆',
    askEnergyClosurePrompt:
      '請說明此 FEA 能量守恆檢查。\n\n{{energyBlock}}\n\n請聚焦時段內 ∫Q·dt 與儲能變化是否閉合（簿記未閉合）。說明下一步該查什麼。請用白話回答；不要使用工具名稱或配線欄位名稱。\n\n{{toolContext}}',
    askTemperatureBounds: '詢問溫度上下限',
    askTemperatureBoundsLabel: '請助理說明最大原理溫度上下限檢查為何未通過',
    askTemperatureBoundsTitle: '溫度上下限',
    askTemperatureBoundsPrompt:
      '請說明此 FEA 溫度上下限檢查。\n\n狀態：{{status}}。上下限：{{bounds}}。\n\n請聚焦是否有節點離開最大原理允許的物理溫度範圍。說明下一步該查什麼。請用白話回答；不要使用工具名稱或配線欄位名稱。\n\n{{toolContext}}',
    askTemperatureBoundsAbsent: '此執行未評定溫度上下限。',
    bodyTemperatures: '本體溫度',
    bodyVolume: '固體體積',
    multiBodyExteriorNote:
      '{{count}} 個固體體積——下列熱流率僅為外邊界面。熱量也會經共用網格接合／接合繫結在體間傳遞（零接觸熱阻）；這些介面傳遞在整體模型總和中相消，與 CHT 能量路徑相同。',
  },
  report: {
    dpVisibilityLabel: '顯示/隱藏設計點',
    dpVisibilityHeading: '顯示中的 DP',
    dpVisibilityItem: 'DP #{{index}} · {{label}}',
    showAll: '全部顯示',
    hideAll: '全部隱藏',
    editTab: '編輯',
    markdownTab: 'Markdown',
    previewTab: '預覽',
    overLimit: '超出上限 {{excess}} 個字元 — 未儲存',
    toolbar: {
      heading2: '標題',
      heading3: '次標題',
      bulletList: '項目符號清單',
      numberedList: '編號清單',
      quote: '引言',
      codeBlock: '程式碼區塊',
      bold: '粗體',
      italic: '斜體',
      strikethrough: '刪除線',
      inlineCode: '行內程式碼',
      link: '連結',
      linkUrl: '連結網址',
      linkApply: '套用',
      linkRemove: '移除連結',
      linkInvalid: '僅 http、https 與 mailto 網址會變成連結。',
      table: '插入表格',
      divider: '分隔線',
      undo: '復原',
      redo: '重做',
    },
    writeWithAi: '以 AI 撰寫',
    writingWithAi: '撰寫中…',
    writerUnavailable: '報告撰寫器目前無法使用，未變更任何內容。',
    writeError:
      '報告撰寫器沒有回應。正在確認是否仍已儲存；若未出現請重新載入。',
    writeRefused: '無法撰寫報告，未變更任何內容。',
    writerInsufficientBasis: '報告撰寫器可用的依據不足，未變更任何內容。',
    writerInsufficientBasisWithDetail:
      '報告撰寫器可用的依據不足，未變更任何內容。{{detail}}',
    writtenByAi: '由報告撰寫器撰寫',
    nothingWrittenYet: '尚未撰寫內容。',
    figureUnavailable: '無法取得圖 {{id}}',
    unsupportedSchema:
      '此報告的內文與圖表由較新版本的 Khorium 產生，系統不會以不完整的形式顯示。請重新載入以取得目前版本。',
    bodyLabel: '報告內文',
    bodyPlaceholder:
      '以 Markdown 撰寫報告。數值、表格與判定為自動產生，不在此編輯。',
    saving: '儲存中…',
    saved: '已儲存',
    savedJustNow: '剛剛已儲存',
    savedAt: '{{ago}}已儲存',
    unsaved: '有未儲存的變更',
    saveError: '無法儲存，下次編輯時會重試。',
    charCount: '{{current}} / {{max}}',
    exportPreparing: '正在準備 PDF…',
    exportFailed: '無法匯出報告，請再試一次。',
    studyReport: '研究報告',
    reportLabel: '報告',
    generated: '產生於 {{date}}',
    contents: '目錄',
    contentsAria: '報告目錄',
    geometryCount_one: '{{count}} 個幾何',
    geometryCount_other: '{{count}} 個幾何',
  },
  chips: {
    cfdExternal: 'CFD · 外流',
    cfdInternal: 'CFD · 內流',
    cht: 'CHT',
    fea: 'FEA',
    modal: '模態',
    cfdTransient: 'CFD · 暫態',
    thermal: 'FEA · 熱傳導',
    thermalTransient: 'FEA · 暫態熱傳導',
    buckling: '挫屈',
    tet: '四面體',
    hex: '六面體',
    poly: '多面體',
  },
  gci: {
    geometry: '幾何',
    grids: '{{count}} 個網格',
    grid: '網格',
    sizeMm: '尺寸 (mm)',
    cells: '單元數',
    r: 'r',
    fine: '細網格',
    variable: '變數',
    fineF1: '細網格 f₁',
    extrap: '外推',
    orderP: '階數 p',
    gciFine: 'GCI 細網格',
    asymptotic: '漸近比',
    oscillatory: '振盪收斂',
    asymptoticTooltip: '越接近 1.0 表示網格處於漸近範圍內',
    skipped: '已略過 GCI 計算',
    skippedReason: '已略過 GCI 計算：{{reason}}',
    noGroups: '沒有幾何群組產生 GCI 結果。',
    computedNote:
      '計算於 {{date}}。GCI 細網格 % 越低表示離散化誤差越小；漸近比接近 1.0 確認網格處於漸近範圍內（Celik 等人，2008）。',
  },
  history: {
    quantity: '物理量',
    perIteration_one: '{{count}} 個點，每次疊代一個',
    perIteration_other: '{{count}} 個點，每次疊代一個',
    perWriteInterval_one: '{{count}} 個點，每個寫入間隔一個',
    perWriteInterval_other: '{{count}} 個點，每個寫入間隔一個',
    thinned: '已抽稀顯示—請看整體趨勢',
    axisTitleHint: '雙擊軸標題即可輸入量的名稱',
    noneRecorded: '沒有逐疊代的記錄',
    noneRecordedHint:
      '這次計算在求解時感測器上線前就完成了，所以沒有歷史資料可畫。新的計算會有。',
  },
  lineProbe: {
    title: '線探測',
    signInToSample: '請登入以沿線取樣數值。',
    field: '物理量',
    feaBackendUpdateRequired:
      '目前的分析服務尚未提供線段取樣。此處會保留線段設定；部署 FEA 取樣器後即可讀取數值。',
    p1At: 'P1 {{axis}} (mm)',
    p2At: 'P2 {{axis}} (mm)',
    pickP1: '在檢視器中選取 P1',
    pickP2: '在檢視器中選取 P2',
    distanceFromP1: '沿線距離 (mm)',
    sampleCount_one: '{{count}} 個點',
    sampleCount_other: '{{count}} 個點',
    needsCoordinates: '請為 P1 與 P2 的每個座標輸入數值。',
    needsDistinct: 'P1 與 P2 必須是不同的點。',
    needsBounds: '正在等待檢視器量測求解區域。',
    missesDomain: '此直線未穿過求解區域——請移動 P1 或 P2。',
    noValueHere: '此處沒有數值',
    gapLegend: '線段離開求解區域的部分以虛線顯示。',
    empty: '此直線上沒有點——請移動 P1 或 P2。',
    failed: '無法對此直線取樣。',
    pickHint: '輸入 P1 與 P2，或啟用十字按鈕後點擊模型來設定該點。',
    pickArmedHint: '點擊模型以設定 {{point}}。按 Esc 取消。',
    regionHint:
      '取樣檢視器中顯示的區域。若要探測介面另一側，請於上方切換區域。',
    extent: '{{min}} 至 {{max}}',
    snap: '對齊',
    snapCentre: '置中',
    points: '取樣點數',
    pointsRange: '{{min}} 至 {{max}}',
    length: '長度',
    lengthValue: '{{value}} mm',
    unavailableFea: '結構分析結果無法使用線探測：沒有可沿直線取樣的求解體積。',
    noRegions:
      '直線取樣需要分區結果，而此次執行早於該功能。若要沿直線繪圖，請重新執行研究。',
    fidelity: {
      exact: '精確',
      interpolated: '內插',
      recorded: '實測',
    },
    fidelityExactTooltip:
      '直接讀取求解器自身的網格單元，不會引入額外的取樣誤差。',
    fidelityInterpolatedTooltip:
      '讀取的是為 3D 檢視器重新取樣的均勻網格，而非求解器網格。由於點距均勻，求解器加密之處反而最粗糙——近壁面誤差約為場範圍的數個百分點。',
    voxelSize: '網格間距 {{size}} mm；小於此尺寸的特徵不會出現在此曲線上。',
  },
  grid: {
    pageLabel: '總覽儀表板',
  },
  sections: {
    lineProbe: '線探測',
    gridConvergence: '網格收斂指標',
    paretoFrontier: '帕累托前緣',
    summary: '摘要',
    methodology: '設定',
    results: '結果',
    guards: '檢核',
    surrogateValidation: '代理模型驗證',
    sensitivity: '敏感度',
    writeup: '撰寫',
    appendix: '附錄',
    chtResults: '共軛熱傳結果',
    chtHandCalcAnchors: '手算基準',
    thermalVisualization: '熱視覺化',
    feaVisualization: 'FEA 視覺化',
    flowVisualization: '流場視覺化',
    comments: '留言',
    commentsWithCount_zero: '留言',
    commentsWithCount_one: '留言（{{count}}）',
    commentsWithCount_other: '留言（{{count}}）',
  },
  dpSelector: {
    showing: '顯示設計點 {{index}} / {{total}}',
    ariaLabel: '切換設計點',
    item: '設計點 {{index}}',
  },
  dpChip: {
    attemptTagTitle: '第 {{attempt}} 次嘗試（共 {{total}} 次）',
  },
  comments: {
    empty: '目前尚無留言。',
    composerPlaceholder: '新增留言…',
    submitHint: 'Cmd/Ctrl + Enter 送出',
    submit: '留言',
    charCount: '{{current}} / {{max}}',
    save: '儲存',
    cancel: '取消',
    edit: '編輯',
    delete: '刪除',
    edited: '（已編輯）',
    unknownAuthor: '未知',
    needsCommenter: '您需要具備留言者以上的權限才能留言。',
    signInToComment: '請登入以留言。',
  },
  pareto: {
    frontierSummary_one:
      '橫跨 {{runs}} 次已完成執行的 {{count}} 個非支配設計前緣（{{dominated}} 個被支配）。點大小依超體積貢獻縮放；懸停可查看設計參數。截至第 {{iteration}} 次迭代，超體積為 {{hypervolume}}。',
    frontierSummary_other:
      '橫跨 {{runs}} 次已完成執行的 {{count}} 個非支配設計前緣（{{dominated}} 個被支配）。點大小依超體積貢獻縮放；懸停可查看設計參數。截至第 {{iteration}} 次迭代，超體積為 {{hypervolume}}。',
    exportTitle: '{{studyName}}; 帕累托前緣',
  },
  executive: {
    completion: '完成度',
    wallClock: '總耗時',
    paretoDesigns: '帕累托設計',
    usable: '可用結果',
    totalRuntime: '總執行時間',
    medianPerPoint: '每點中位數',
    hvGain: '超體積增益',
    pick: '選擇',
    design: '設計',
    best: '最佳 {{objective}}',
    paretoKnee: '帕累托拐點',
    sweptSummary_one: '橫跨 {{runs}} 次已完成執行掃掠了 {{count}} 個目標',
    sweptSummary_other: '橫跨 {{runs}} 次已完成執行掃掠了 {{count}} 個目標',
    usingSampling: '，使用 {{method}} 抽樣',
    ranSummary_one: '已完成 {{count}} 個設計點的運算',
    ranSummary_other: '已完成 {{count}} 個設計點的運算',
    paretoSentence_one: ' 帕累托前緣包含 {{count}} 個非支配設計。',
    paretoSentence_other: ' 帕累托前緣包含 {{count}} 個非支配設計。',
    validationSentence: ' 代理模型驗證：{{metrics}}。',
    driverSentence: ' 主要驅動因子：{{input}} 對 {{response}}（Sₜ={{st}}）。',
  },
  methodology: {
    patchRegion: '表面積來源區域',
    noConfig: '未記錄任何設定',
    inputs: '輸入',
    geometries: '幾何',
    meshes: '網格',
    mesh: '網格',
    strategy: '策略',
    elementType: '單元類型',
    maxSize: '最大尺寸',
    minSize: '最小尺寸',
    elementOrder: '單元階數',
    cellCount: '單元數',
    cellsUnit: '單元',
    skewnessMax: '偏斜度（最大）',
    aspectRatioMax: '長寬比（最大）',
    wedgeCellCount: '邊界層稜柱單元',
    meshVolume: '網格體積',
    perRegionVolumes: '各區域體積',
    perInterfaceArea: '各界面濡潤面積',
    boundaryLayer: '邊界層',
    curvatureRefine: '曲率細化',
    externalEnclosure: '外部包圍',
    on: '開啟',
    sampling: '抽樣',
    method: '方法',
    n: 'N',
    scramble: '擾動',
    seed: '種子',
    solver: '求解器',
    showAdvanced: '顯示進階設定 ({{count}})',
    hideAdvanced: '隱藏進階設定',
    boundaryConditions: '邊界條件',
    objectivesOptimization: '目標與最佳化',
    objectives: '目標',
    maxIterations: '最大迭代次數',
    batchSize: '批次大小',
    rows: {
      template: '範本',
      fluid: '流體',
      density: '密度',
      turbulence: '紊流模型',
      flowAxis: '流動軸',
      inletVelocity: '入口速度',
      outletPressure: '出口壓力',
      inletTemperature: '入口溫度',
      exteriorThermal: '外表面熱邊界條件',
      adiabaticExterior: '絕熱（未指定）',
      targetTemperature: '目標溫度',
      enclosureFaces: '外圍面',
      referenceArea: '參考面積 (A_ref)',
      referenceChord: '參考翼弦 (l_ref)',
      hydraulicDiameter: '水力直徑 (D_h)',
      characteristicLength: '特徵長度 (L)',
      bodySurfaceArea: '物體表面積',
      inletArea: '入口面積',
      outletArea: '出口面積',
      enclosureArea: '外圍面表面積',
      projectedFrontalArea: '投影正面積 ({{axis}})',
      bodyBbox: '物體外接盒 (X × Y × Z)',
      enclosureBbox: '外圍外接盒 (X × Y × Z)',
      bodyVolume: '物體體積',
      enclosureVolume: '外圍體積',
      bcSets: '邊界條件集',
      fixedTFaces: '固定溫度面',
      endTime: '結束時間',
      timestep: '時間步長',
      timeAveragingStart: '平均起始',
      maxCourant: '最大 Courant 數',
      outerCorrectors: '外迴圈修正次數',
      writeInterval: '寫出間隔',
      conductivity: '熱傳導率',
      heatFluxFaces: '熱通量面',
      radiationFaces: '輻射面',
      convectionFaces: '對流面',
      fixedTDetail: '固定溫度 · {{value}} K',
      heatFluxDetail: '熱通量 · {{value}} W/m²',
      convectionDetail: '對流 · h {{h}} W/(m²·K) · 環境 {{ambient}} K',
      radiationDetail: '輻射 · ε {{emissivity}} · 環境 {{ambient}} K',
      pointHeatDetail: '節點熱負載 · {{value}} W',
      nodeLabel: '節點 {{nodeId}}',
      volumetricHeatBc: '體積發熱 (BC)',
      surfaceHeatFlux: '表面熱通量',
      regions: '區域',
      fluidMaterial: '流體材料',
      fluidDensity: '流體 ρ (密度)',
      fluidViscosity: '流體 ν (運動黏滯係數)',
      fluidCp: '流體 c_p (比熱)',
      fluidConductivity: '流體 k (熱傳導係數)',
      fluidPrandtl: '流體 Pr (Prandtl 數)',
      solidMaterial: '固體材料',
      solidProperties: '固體物性 (k, ρ, c_p)',
      solidK: '固體 k (熱傳導率)',
      solidDensity: '固體 ρ (密度)',
      solidCp: '固體 c_p (比熱)',
      regionHeatSource: '區域熱源',
      material: '材料',
      yieldUltimate: '降伏 / 抗拉強度',
      volumeMaterials: '體積材料',
      restraint: '拘束',
      gravity: '重力',
      centrifugal: '離心荷重',
      axialCoupling: '軸向耦合',
      contact: '接觸',
      boltPreload: '螺栓預載',
      shrinkPreload: '熱收縮預載',
      modes: '模態數',
      faces: '面',
      cutbacks: '增量回退',
      cutbacksOn: '啟用',
      cutbacksOff: '停用（快速失敗）',
      frictionless: '無摩擦',
      derived: '自動導出',
      studyDefault: '研究預設值',
      bonded: '黏合',
      tieTolerance: '容許距離 {{mm}} mm',
      tieToleranceDefault: '2 mm（預設）',
      cutbacksLimited: '啟用（每個增量最多 {{n}} 次）',
      increments: '載重增量',
      incrementsFirstMax: '首次 載重的{{initial}} · 最大 {{maximum}}',
      incrementsMin: '最小 {{minimum}}',
      target: '目標',
      contactPairs: '接觸',
      boltPreloads: '預力',
    },
    templates: {
      external_flow: '外流 (CFD)',
      internal_flow: '內流 (CFD)',
      urans: '暫態流 (CFD)',
      cht_steady: '共軛熱傳 (CHT)',
      thermal_conduction: '熱傳導 (FEA)',
      thermal_transient: '暫態熱傳導 (FEA)',
      structural_static: '結構靜態 (FEA)',
      modal_frequency: '模態頻率 (FEA)',
      linear_buckling: '線性挫屈 (FEA)',
    },
    templatesShort: {
      external_flow: '外流',
      internal_flow: '內流',
      urans: '暫態流',
      cht_steady: '共軛熱傳',
      thermal_conduction: '熱傳導',
      thermal_transient: '暫態熱傳導',
      structural: '結構',
    },
    bcTypes: {
      velocity_inlet: '速度入口',
      pressure_outlet: '壓力出口',
      wall_no_slip: '無滑移壁',
      slip: '滑移',
      symmetry: '對稱',
      freestream: '自由流',
      fixed: '固定',
      load: '荷重',
      pointLoad: '點載重',
      pressure: '壓力',
      restraint: '拘束',
      prescribed: '指定位移',
      held: '拘束',
      free: '自由',
    },
    enclosureRoles: {
      inlet: '入口',
      outlet: '出口',
      farfield: '遠場',
    },
    autoFromFlowAxis: '依流動軸自動判定',
    regionRoles: {
      fluid: '流體',
      solid: '固體',
    },
    materialCustomOverride: '使用者覆寫',
    units: {
      kinematicPressure: 'm²/s²（運動壓力）',
    },
    titles: {
      inletPlaneExt: '自由流速度沿流動軸方向, 由入口面法線方向流入.',
      inletPlaneExtWithAxis:
        '自由流速度沿 +{{ax}} 方向前進, 由 −{{ax}} 面即入口面法線方向流入.',
      outletPlaneExt: '出口面上的靜壓, 與流動軸垂直 (法線方向).',
      outletPlaneExtWithAxis:
        '+{{ax}} 面即出口面上的靜壓, 與流動軸垂直 (法線方向).',
      inletPlaneInt: '流體沿入口面片的法線方向進入計算域.',
      outletPlaneInt: '壓力施加於出口面片並沿其法線方向.',
      valueFromPatch: ' 數值取自 {{patchType}} 面片邊界條件.',
      chtInletVelocity: '沿入口面片法線方向進入計算域的流體速度.',
      adiabaticExterior:
        '任何面都未指定溫度、對流係數或熱通量，因此除區域界面以外的所有表面都不放熱。因為沒有對外路徑，穩態下界面必須恰好帶走宣告的功率。',
      declaredExterior:
        '帶有熱邊界條件的標記面。熱可以不經冷卻液離開，因此界面總量不必等於宣告功率。',
      chtInletTemperature: '流體於入口進入時的溫度.',
      chtOutletPressure:
        '出口面片上的靜壓, 與其面垂直. 以運動學壓力 (p/ρ) 儲存.',
      targetTemperature: '本研究最佳化所欲逼近的設計目標溫度.',
      chtFixedTFaces:
        '求解過程中固定溫度的固體面。每個面作為 Dirichlet 邊界 — 鄰接單元被固定為所列數值，熱量從固體流入或流出以閉合平衡。',
      uransEndTime:
        '模擬的物理時間總量。暫態分析以模擬時間終止，而非以疊代次數終止。',
      uransTimestep:
        '起始物理時間步長。adjustTimeStep 會在執行中即時縮小以維持 Courant 目標，因此很少全程維持此值。',
      uransTimeAveraging:
        '平均場在此時刻到結束時間的區間內計算，該平均即為回報的 URANS 結果。請在起始暫態結束後才開始，否則平均會把它一併算入。',
      uransMaxCourant:
        '自適應時間步長維持的 Courant 目標。pimpleFoam 在遠高於 1 時仍穩定，但解會偏移；當空間梯度主導物理時應調低。',
      uransOuterCorrectors:
        'PIMPLE 外迴圈次數。1 等同純 PISO，在非正交網格上會偏移；2 是標準混合；更高則趨近每個時間步一次完整的 SIMPLE 疊代。',
      uransWriteInterval:
        '寫入磁碟的場快照之間的模擬時間。它決定重播的精細度，而非求解方式。',
      thermalConductivity:
        '來自熱材料庫的熱傳導率。在穩態下這是唯一影響結果的材料性質；密度與比熱決定達到平衡的快慢，而非最終落點。',
      thermalFixedTFaces:
        '溫度固定的面。每一個都是 Dirichlet 邊界，熱量會依需要進出以維持該值。',
      thermalHeatFluxFaces: '指定表面熱通量的面。正值表示熱量流入物體。',
      thermalConvectionFaces:
        '透過薄膜係數 h 與環境耦合的面，q = h · (T_wall − T_ambient)。典型 h：自然對流空氣約 5、強制空氣約 50、水約 1000 以上。',
      thermalRadiationFaces:
        '向環境輻射的面。deck 輸出 ε·σ，因此顯示的放射率是輸入值，而非乘積。',
      chtConvectionFaces:
        '透過熱傳係數 h 與環境浴耦合的固體面。跨面的熱通量為 q = h · (T_wall − T_ambient)；h 越大表示該面越積極散熱。典型 h：自然對流空氣 ~5、強制對流空氣 ~50、水 ~1000+、沸騰 ~10k+。',
      chtVolumetricHeatBc:
        '應用於固體區域的體積級發熱 — 均勻分布於體積內的 W/m³。求解器注入的總熱功率為此密度乘以已網格化區域體積。',
      chtSurfaceHeatFlux:
        '以規定熱通量驅動的固體面 — 沿面法線方向的 W/m²。正值代表熱進入固體；負值代表熱被抽出。',
      chtRegions:
        'CHT 將已網格化的體積分為流體與固體區域，各自擁有材料屬性與邊界條件集合。兩者的界面自動耦合，使兩側的溫度與熱通量相符。',
      chtFluidMaterial:
        '各流體區域使用的冷媒 — ρ、ν、c_p、Pr 由以此名稱為鍵的流體材料庫取得。「custom override」標籤表示此次執行至少有一項為手動輸入。',
      chtSolidMaterial:
        '各區域的固體材料 — 熱傳導率 k、密度 ρ、比熱 c_p 由以此名稱為鍵的熱物性材料庫取得。',
      chtFluidProperties:
        '各流體區域的 ρ / ν / c_p / Pr。除非該區域有自訂覆寫 (rho / nu / cp / pr)，否則取材料庫值。',
      chtFluidDensity: '各材料的流體密度 ρ (取材料庫值；自訂覆寫依區域列出)。',
      chtFluidViscosity: '各材料的流體運動黏滯係數 ν。',
      chtFluidCp: '各材料的流體比熱 c_p。',
      chtFluidConductivity: '各材料的流體熱傳導係數 k。',
      chtFluidPrandtl:
        '各材料的流體 Prandtl 數 Pr (無因次) — 由 ρ·ν·c_p/k 推算，即傳給求解器的值。',
      chtSolidProperties:
        '各固體區域的 k / ρ / c_p。以區域材料名稱為鍵，從熱物性材料庫取值。',
      chtSolidK: '各材料的固體熱傳導率 k。',
      chtSolidDensity: '各材料的固體密度 ρ。',
      chtSolidCp: '各材料的固體比熱 c_p。',
      chtRegionHeatSource:
        '應用於各固體區域的熱源。單位為 W（總熱功率源，由 case writer 分佈於網格化區域體積）或 W/m³（體積密度，直接應用於每個單元）。',
      density:
        '流體密度 ρ. 亦為將運動學壓力 (m²/s²) 轉換為絕對壓力 (Pa) 的比例因子.',
      outletKinematicWithRho:
        ' 以運動學壓力 (p/ρ) 儲存; 切換單位可讀取絕對壓力 (ρ = {{rho}} kg/m³).',
      outletKinematic: ' 以運動學壓力 (p/ρ) 儲存.',
      structuralYieldUltimate: '材料降伏強度與極限抗拉強度, 取自結構材料庫.',
      structuralVolumeMaterials: '多本體組件的逐體積材料覆寫.',
      structuralContactPair:
        '互相擠壓但未結合的面：僅傳遞壓力，可自由分離。求解因此成為非線性。',
      structuralShrinkPreload:
        '藉由冷卻螺栓產生的預力。此力為目標值 — 柔性接頭會低於目標，因此案例會校正，實際達成的力隨結果一併回報。',
      structuralBoltPreload: '透過切過螺桿的預拉斷面鎖在螺栓中的張力。',
      structuralCutbacks:
        '求解器是否可將無法收斂的增量減半。預設停用：無法完成該步的求解會直接停止，而非一路細分下去。',
      structuralTiedInterface:
        '彼此黏合的面：可傳遞拉力、剪力與壓力，且永不分離。容許距離內的從屬節點會在原位置與對面綁定，跨越兩網格之間的間隙。求解維持線性。',
      thermalTiedInterface:
        '為溫度連續而黏合的面：CalculiX *TIE 使介面溫度相等，讓獨立網格物體之間能傳熱。容許距離內的節點會被綁定；求解維持線性。',
      structuralIncrements:
        '接觸步驟如何施加載重：首次增量、求解器可採用的最大增量，以及減半時可縮到的最小增量，皆以總載重的比例表示。',
      referenceArea:
        '用於正規化升力與阻力係數 (C_L, C_D) 的參考面積. 面積越大, 相同力對應的係數越小.',
      referenceChord:
        '用於正規化俯仰力矩係數 (C_M) 的參考長度. 翼弦越長, 相同力矩對應的 C_M 越小.',
      chtHydraulicDiameter:
        '冷媒流道的 D_h (讀者宣告值). 供給手算錨點 D_h 列 + Bi / Nu / j 雷達軸. 求解器不使用.',
      chtCharacteristicLength:
        '手算錨點集合 + 與 L 有關雷達軸使用的 L (讀者宣告值). 求解器不使用.',
    },
    faceGroupHeader_one: '{{count}} 個面群組',
    faceGroupHeader_other: '{{count}} 個面群組',
    nFaces_one: '{{count}} 個面',
    nFaces_other: '{{count}} 個面',
  },
  results: {
    runStatistics: '執行統計',
    completed: '已完成',
    failed: '失敗',
    cancelled: '已取消',
    inProgress: '進行中',
    runtimePerPoint: '每個已完成點的執行時間; 中位數 {{median}} · p95 {{p95}}',
    failureCount_one: '{{count}}×',
    failureCount_other: '{{count}}×',
    topDesigns: '頂尖設計',
    dpTableHeading: '設計點表',
    deltaTableHeading: '設計點差異 (各 DP 對基準 DP)',
    by: '依 {{label}}',
    rank: '排名',
    design: '設計',
    crossReferences: '帕累托前緣 → 代理模型驗證 → 敏感度 → 網格收斂',
  },
  referenceComparison: {
    heading: '參考比較',
    pickerLabel: '參考:',
    pickerPlaceholder: '選擇參考…',
    clear: '清除',
    empty:
      '此處放置引文式參考比較。從上方庫中選擇參考; 匹配率超出其宣告容差,即是把執行轉為驗證的發現。',
    noCompletedDps: '尚無完成設計點; 所選參考沒有比較對象。',
    noAnchorsForTemplate:
      '本研究的模板在庫中無公開參考。跳過此節或提案新增庫項。',
    dp: 'DP',
    quantity: '量',
    ours: 'Sim',
    reference: '參考',
    tolerance: '容差',
    source: '出處',
    rePerDp: '各 DP 之 Re:',
    chartCaption: '實線: 各 DP 求解器值 · 虛線: 各 DP 參考相關 · X = {{xAxis}}',
    bestMatchTooltip:
      '此庫中對本執行的平均 |Δ| 最小。並非排名; 挑選前請確認形狀相符。',
    sensitivityMismatch:
      '此參考取決於 {{anchorAxis}},但 DOE 掃描 {{sweepAxis}}; 參考曲線在所有 DP 上會呈水平線。請掃描 {{anchorAxis}},或選擇依 {{sweepAxis}} 而變的參考。',
    feOnlyNote: '開發中。所選參考尚未儲存; 重新載入報告後選擇器會重置。',
    anchors: {
      sphereCd: {
        label: '球體 · C_D · Schiller–Naumann',
        citation:
          'Schiller & Naumann (1933). Über die grundlegenden Berechnungen bei der Schwerkraftaufbereitung. VDI, 77. 適用於剛性光滑球體,亞臨界 Re 域 (Re ≲ 3.5×10⁵);超過此界 C_D 急降,此相關式已無法涵蓋。',
        qtyCd: 'C_D (阻力係數)',
      },
      thinAirfoilCl: {
        label: '薄翼 · C_L(α) · 2π 理論',
        citation:
          'Anderson, J. D. Fundamentals of Aerodynamics, 6th ed. 薄翼理論:非黏性不可壓縮流中對稱薄翼,C_L = 2π·α。從各 DP 的迎角讀取 α,產生 Cl-vs-α 掃描的參考線。±10% 涵蓋 NACA 24xx 附近彎度貢獻;高彎度 / 高升力翼型不在此範圍。',
        qtyCl: 'C_L (升力係數)',
      },
      handCalcShapes: {
        citation:
          '沙盒手算形狀庫 (Hoerner, Fluid-Dynamic Drag;Anderson, Fundamentals of Aerodynamics;ESDU 空氣動力資料;White, Fluid Mechanics)。教科書中間值; 供健全性檢查,並非發表級驗證目標。',
      },
      suddenExpansion: {
        label: '管道擴大 · ζ · Borda-Carnot',
        citation:
          'Borda-Carnot 損失 (面積突變):ζ = (1 − A_in / A_out)²。White, Fluid Mechanics 第 8 版 §6.9。適用於直角段差的湍流;帶角度擴散器與非圓形管道超出 ±15% 帶。',
        qtyZeta: 'ζ (損失係數)',
      },
      pipeFrictionLaminar: {
        label: '管摩擦 · ζ · Poiseuille (層流)',
        citation:
          'Darcy-Weisbach 搭配 Hagen-Poiseuille 摩擦係數:f = 64 / Re, ζ = f · L / D_h。White, Fluid Mechanics §6.4。適用於圓形直管 Re < 2300;過渡與湍流區需 Colebrook / Blasius (後續錨點)。',
        qtyZeta: 'ζ (損失係數)',
      },
    },
    shapeWarning: {
      generic:
        '假設本體為: {{anchor}}. 引用偏差前請確認幾何實際符合; 形狀不在紀錄中,選錯參考不會顯示為錯誤,只會呈現為不合適的比較.',
    },
  },
  domainSchematic: {
    ariaLabel:
      '域示意圖; 中央為本體,左為入口箭頭,右為出口標註,上下為遠場標籤。',
    figureLabel: '域示意圖',
    sectionHeading: '邊界條件',
    caption: '網格化的域與邊界條件。',
    inletVelocity: '速度入口',
    inletVelocityInternal: '速度入口',
    uNotDeclared: 'U 未宣告',
    outletPressure: '壓力出口',
    pNotDeclared: 'p 未宣告',
    farfieldTop: '遠場 (滑動壁)',
    farfieldBottom: '遠場 (滑動壁)',
    wallLabel: '壁 (無滑) · 弦長 {{chord}}',
    wallLabelInternal: '壁 (無滑)',
    nonWallPatchInternal: '此面並非每個 patch 都是壁',
    arefDeclared:
      'A_ref 宣告值 {{value}} m²。隱含正面投影面積 (弦長 × 展弦) 待 mesh bbox × span 上導線後顯示;>100× 落差時驗證區段的單位尺度檢查會觸發。',
    schematicCaveat: '非比例·非幾何。',
  },
  assumptions: {
    heading: '假設',
    intro:
      '所有數字所依賴的假設。↑ 表示假設使報告值上升；↓ 表示被忽略或合併的效應使報告值下降。○ 表示方向取決於載荷路徑，或無法合理指定方向；不代表省略項目沒有影響。',
    introPrefix: '所有數字所依賴的假設。',
    introInflating: '誇大 (↑) = 模型將某項視為比物理更大。',
    introIgnoring: '忽略 / 合併 (↓) = 已知被省略的效應會使報告值下降。',
    introNeutral:
      '○ = 方向取決於載荷路徑，或無法合理指定方向；不代表省略項目沒有影響。',
    direction: {
      up: '誇大; 模型相對於物理過度呈現此項',
      down: '被忽略或合併的效應使報告值下降',
      none: '方向取決於載荷路徑，或無法合理指定方向',
    },
    steadyRans: {
      title: '穩態 RANS,k-ω SST',
      body: '湍流被建模而非解析;實流動中的任何非穩態性僅以監測量的散布帶形式呈現。',
    },
    incompressible: {
      title: '不可壓縮',
      body: 'U = {{u}} m/s (M ≈ {{mach}}) 時可壓縮性效應遠低於報告精度。',
      bodyNoU:
        '假設可壓縮性效應遠低於報告精度;流動快於風洞情境時請以入口速度確認。',
    },
    fullyTurbulent: {
      title: '全湍流邊界層; 無過渡模型',
      body: '低雷諾數下實際邊界層可能為部分層流;以全湍流建模會使摩擦阻力相對物理流動向上偏。',
    },
    fullyTurbulentInternal: {
      body: '未建模部分層流的入口區;發展區的報告壓降可能高於物理值。',
    },
    smoothWall: {
      title: '水力光滑表面',
      body: '未建模粗糙度;實表面會使阻力向上偏,故報告 C_D 低於物理阻力。',
    },
    smoothWallInternal: {
      body: '未建模粗糙度;實表面會使壓降向上偏,故報告 Δp 低於物理值。',
    },
    farfieldBlockage: {
      title: '遠場為滑移壁邊界',
      body: '阻塞 (本體正面投影面積佔風洞截面的比例) 在宣告遠場比之下雖小,但仍具限制性,會將局部速度與升力斜率向上推。開發中:阻塞比列將在驗證區段顯示確切比例。',
    },
    fluidProperties: {
      title: '流體採宣告的 ρ 與 ν',
      body: '所有係數 (C_D、C_L、C_M) 皆以 q = ½ρU² 正規化,錯誤的 ρ 或 U 會等比例縮放每一項。報告無法判定宣告值是否正確; 僅能確認是使用者選定的數值。',
      bodyInternal:
        '報告的壓降 Δp 與 ρ 成線性,損失係數 ζ = 2·Δp / (ρU²) 同時受 ρ 與 U 影響。錯誤的 ρ 或 U 會等比例縮放兩者。報告無法判定宣告值是否正確; 僅能確認是使用者選定的數值。',
    },
    shapeAnalyst: {
      title: '截面形狀依分析師確認',
      body: '手算沙盒的參考從此確認中選出; 而非依研究名稱。',
    },
    geometryTags: {
      title: '入口 / 出口標籤依宣告',
      body: '報告將標為 "inlet" 的面片視為預期入口; 錯標的出口也能滿足質量守恆,但量測的是錯誤的埠。標籤是否符合意圖由讀者確認。',
    },
    feaStatic: {
      title: '靜力、小位移平衡',
      body: '載荷不含慣性或時間歷程，且剛度不會依變形後幾何更新。後端沒有小位移適用性的截斷值；剛體運動診斷只會拒絕超過模型對角線 10,000 倍的異常增量（無尺寸時採 1,000,000 mm），這是失敗偵測而非有效性界線。',
    },
    feaEnergyEquilibrium: {
      title: '僅求機械平衡',
      body: '求解會平衡外加載荷與反力，但不求解溫度場或熱能守恆，因此不能推論熱平衡或能量閉合判定。',
      bodyWithPreload:
        '求解會平衡外加載荷與反力。熱收縮預緊以指定的虛擬溫差產生應變；不求解熱傳、熱平衡或能量守恆。',
    },
    feaLinearElastic: {
      title: '線彈性材料',
      body: '應力依材料庫數值與應變成正比。未建模塑性、損傷、潛變或隨溫度變化的物性。',
    },
    feaMaterials: {
      title: '宣告的材料配置',
      bodyGlobal: '整個模型採用一種材料；所有本體使用相同的彈性與密度物性。',
      bodyByVolume:
        '{{materials}} 種材料配置於 {{volumes}} 個體積；各體積保留自己的彈性、強度與密度物性。',
    },
    feaSupports: {
      title: '由宣告支撐限制剛體運動',
      body: '{{count}} 個固定或分軸支撐依其標記面或本體施加；夾具本身的柔度未納入。',
    },
    feaLoads: {
      title: '僅採宣告的載荷組',
      bodyWithBodyForces:
        '包含 {{loads}} 個面、邊、壓力或耦合載荷，以及 {{bodyForces}} 個重力或離心本體載荷。',
      bodyWithoutBodyForces:
        '包含 {{loads}} 個面、邊、壓力或耦合載荷。未宣告重力或離心本體載荷，因此不含自重與旋轉效應。',
    },
    feaInitialState: {
      title: '初始應力狀態',
      bodyNoPreload: '組件由無應力狀態開始；未宣告螺栓預緊或熱收縮預緊階段。',
      bodyWithPreload:
        '{{count}} 個螺栓或熱收縮預緊階段先建立初始受力狀態，再施加工作載荷。',
    },
    feaContact: {
      title: '小滑移接觸',
      body: '{{count}} 組宣告接觸以小滑移運動學傳遞法向與切向牽引力。後端將每組接觸的滑移尺度報告為 μ × 峰值接觸壓力 ÷ 黏著斜率；低於此尺度的位移可能只是彈性黏著，不建模有限滑移與大轉動。',
    },
    feaCutbacks: {
      title: '非線性增量切回',
      bodyEnabled: '接觸或預緊步驟已啟用自動切回；平衡困難時求解器可縮小增量。',
      bodyDisabled:
        '自動切回已停用；接觸或預緊步驟若無法在排定增量達到平衡會直接失敗，不會自動改用較小步長。',
    },
    feaModalEigenvalue: {
      title: '線性、無阻尼特徵值分析',
      body: '從無預應力構形擷取前 {{count}} 個振型。此模態模型不含外加載荷、阻尼、接觸張開或預緊勁化。',
    },
    thermalConduction: {
      steadyState: {
        title: '定常傳導',
        body: '求解與時間無關的溫度場。不模擬啟動瞬態或占空比循環。',
      },
      singleMaterial: {
        title: '單一固體材料',
        body: '所有體積使用熱材料庫中的 {{material}}。',
      },
      declaredBcs: {
        title: '已宣告的面條件',
        bodyNone: '沒有面宣告明確熱 BC。未處理的面皆為絕熱。',
        bodyWithInventory: '已標記面：{{inventory}}。其餘面為絕熱。',
      },
      inventory: {
        fixedT: '{{count}} 個固定溫度',
        heatFlux: '{{count}} 個熱通量',
        pointHeat: '{{count}} 個節點熱負載',
        convection: '{{count}} 個對流',
        radiation: '{{count}} 個輻射',
        separator: '、',
      },
      adiabaticUntreated: {
        title: '未處理面為絕熱',
        body: '未宣告條件的面法向熱通量為零，熱只能從您指定的面離開。',
      },
      noThermalInterfaces: {
        title: '體間無熱介面',
        body: '此模板不耦合多體組件的共用介面。每個體作為單一材料域求解。',
      },
      perfectContactSharedNodes: {
        title: '共用網格接合為理想熱接觸',
        body: '接觸面共用節點，溫度連續且熱量以零接觸熱阻傳遞——與 CHT 耦合介面相同的理想化。實際接頭與介面層會增加熱阻，因此同樣功率下實物溫度更高。',
      },
      perfectContactTies: {
        title: '接合繫結為理想熱接觸',
        body: '每個接合繫結使介面溫度自由度相等（CalculiX *TIE），熱量以零接觸熱阻傳導。實際接頭會增加約十分之一 K/W 的熱阻，因此同樣功率下實物溫度更高。',
      },
      steadyMaterialProps: {
        title: '定常解不含密度與比熱',
        body: '定常狀態下僅傳導率影響溫度場。ρ 與 c_p 支配瞬態升溫，不影響定常值。',
      },
    },
    chtSteadyEquilibrium: {
      title: '穩態平衡',
      body: '啟動、泵浦爬升與循環工作模式僅以收斂行為呈現; 結果為穩定的溫度場,對達到時間並無資訊。',
    },
    chtFrozenFluidProperties: {
      title: '流體物性固定於單一溫度',
      body: 'ρ、μ、c_p、k 皆採宣告條件下的資料庫值。黏性隨溫度變化,流體溫升較大的執行會以較稠的流體被求解, 使 Δp 讀值偏高。ΔT 超過數 K 時請確認。',
      bodyWithMaterial:
        '{{fluid}} 的 ρ、μ、c_p、k 皆採宣告條件下的資料庫值。黏性隨溫度變化,流體溫升較大的執行會以較稠的流體被求解,使 Δp 讀值偏高。ΔT 超過數 K 時請確認。',
      bodyWithMaterialAndDT:
        '{{fluid}} 的 ρ、μ、c_p、k 皆採宣告條件下的資料庫值。本次流體溫升 {{dt}} K — 黏性隨溫度變化,但仍以較稠的流體被求解,使 Δp 讀值偏高。ΔT 超過數 K 時請確認。',
    },
    chtNoBuoyancy: {
      title: '無浮力',
      body: '密度固定,不論重力設定,自然對流的熱傳貢獻皆為零。適用於 Gr / Re² ≪ 1; 低流量或無流量情境下,此模型唯一剩餘的熱路徑會消失。',
    },
    chtPerfectThermalContact: {
      title: '接合處完全熱接觸',
      body: '耦合溫度界面接觸熱阻為零; 實際界面層與機械接合處會加上 0.1 K/W 量級的阻抗,相同功率下實機會比此模型更熱。通常是模型與實機量測最大單一差距。',
    },
    chtUniformHeatSource: {
      title: '發熱源體積內均勻分布',
      body: '宣告的功率均勻分布於整個發熱區域; 發熱源內的局部熱點會高於報告的區域最高溫度。',
      bodyWithQ:
        '宣告的 {{q}} 均勻分布於整個發熱區域; 發熱源內的局部熱點會高於報告的區域最高溫度。',
    },
    chtAdiabaticExternalWalls: {
      title: '外壁絕熱',
      body: '外表面無自由冷卻,所有功率均需由流體帶走。實機亦會向環境散熱,故報告溫度會高於實機。對熱裕度而言是保守假設。',
    },
    chtNoRadiation: {
      title: '無輻射',
      body: '此溫度區間內佔傳熱百分之幾, 隨 T⁴ 成長; 被動或氣冷組態需重新考量。',
    },
    chtTurbulenceModel: {
      title: '湍流模型 (k-ω SST), 以定值 Pr_t 橋接熱傳',
      body: 'h 繼承壁面處理品質: 壁面間距檢查決定對流側的可信度。層流執行中,此列改為「確認 Re 落在層流範圍」。',
      bodyWithModel:
        '湍流模型 ({{model}}), 以定值 Pr_t 橋接熱傳。h 繼承壁面處理品質: 壁面間距檢查決定對流側的可信度。',
      titleLaminar: '假設層流',
      bodyLaminar:
        '無湍流封閉; 動量與熱邊界層皆直接解析。請確認 Re 落於此流道的層流範圍 — 過渡區情境下 h 讀值偏低。',
    },
    chtUniformInlet: {
      title: '均勻入口: 單一溫度, 單一速度',
      body: '埠上游岐管分布不均將以入口條件誤差呈現,與發展長度註解相連。',
      bodyWithT:
        '入口為單一溫度 ({{t}} °C) 與單一速度。埠上游岐管分布不均將以入口條件誤差呈現,與發展長度註解相連。',
      bodyWithTAndU:
        '入口為單一溫度 ({{t}} °C) 與單一速度 ({{u}} m/s)。埠上游岐管分布不均將以入口條件誤差呈現,與發展長度註解相連。',
    },
    chtAdiabaticExterior: {
      title: '外表面視為絕熱',
      body: '任何面都未指定熱邊界條件，因此除區域界面以外的所有表面都不放熱。實際組件也會向環境散熱，所以固體溫度會偏高；且因為沒有對外路徑，穩態下界面必須恰好帶走宣告的功率。',
    },
    chtDeclaredExterior: {
      title: '外表面帶有指定的邊界條件',
      body: '有 {{count}} 個標記面指定了溫度、對流係數或熱通量。熱可以不經冷卻液離開組件，因此界面總量不必等於宣告功率。',
    },
    chtSolverSafetyLimits: {
      title: '求解器安全上限已啟用',
      body: '未觸及的上限不可見; 大量鉗制代表解被求解器維持在邊界內。鉗制檢查會評估實際發生的鉗制量。',
      bodyWithLimits:
        '溫度鉗制於 [{{tMin}}, {{tMax}}] °C; 速度鉗制於約 {{uMax}} m/s。未觸及的上限不可見, 大量鉗制代表解被求解器維持在邊界內。',
    },
  },
  chtHeadline: {
    peakNamed: '{{region}} 最高溫度: {{tmax}}。',
    peakUnnamed: '固體最高溫度 {{tmax}}。',
    withinNamed: '{{region}} 最高溫度: {{tmax}} — 未超過 {{limit}} 上限。',
    withinUnnamed: '固體最高溫度 {{tmax}} — 未超過 {{limit}} 上限。',
    exceedsNamed: '{{region}} 最高溫度: {{tmax}} — 超過 {{limit}} 上限。',
    exceedsUnnamed: '固體最高溫度 {{tmax}} — 超過 {{limit}} 上限。',
  },
  regionGraph: {
    heading: '區域圖',
    intro:
      '本次執行所建模的每條熱路徑皆有繪出。Q̇ 進入發熱源固體 (左側)。灰色箭頭為固體-固體傳導、藍色箭頭為傳入冷媒的對流。箭頭標籤為穩態下橫越該界面的「淨總瓦數」— 執行積分後的速率, 不是尖峰或平均值。此處符號取絕對值, 方向由箭頭本身表示。尖峰熱通量 (W/m²) 顯示於概覽卡, 而非箭頭上。',
    parallelFlowNote:
      '固體區塊由左至右依「主要相鄰邊」排列。若一個固體與多個固體相鄰，只畫出主鏈那條邊；其餘邊仍計入區塊內的合計。逐界面完整拆分列於 DP 詳細結果列。',
    stateToggleAria: '在宣告輸入與求解輸出之間切換',
    stateDeclared: '宣告值',
    stateSolved: '求解值',
    stateDeclaredHint:
      '顯示設定所要求的值 — 入口溫度、Q̇、目標 T。區塊內的溫度讀取 BC。',
    stateSolvedHint: '顯示求解結果 — 穩態區域 T、界面熱通量、冷媒 ΔT。',
    ambientLabel: '外環境 · 絕熱 (無外部熱流)',
    ambientLabelDeclared: '環境 · 外表面已指定邊界條件',
    sourceMarker: '發熱源',
    fluidRangeMissing: '摘要無溫度範圍',
    hottest: '本次執行的最高溫固體。',
    hottestBadge: '最熱',
    regionRoleSolid: '固體',
    regionRoleFluid: '流體',
    tooltipHeatSource: '宣告發熱源',
    tooltipHeatSourceUnknown: '宣告發熱源: 總功率未在資料中。',
    tooltipConvection: '對冷媒的對流',
    tooltipConvectionUnknown:
      '對流瓦數尚未在資料中 (舊執行)。此面不是絕熱。此固體與冷媒之間有實際溫度梯度, 熱確實在流動; 只是這次執行沒記錄數值。',
    tooltipConduction: '對相鄰固體的傳導',
    tooltipConductionUnknown:
      '傳導瓦數尚未在資料中 (舊執行)。此界面不是絕熱。相鄰固體共用同一面且有溫度梯度, 熱確實在流動; 只是這次執行沒記錄數值。',
    tooltipSignHint: '(符號: + = 熱由此固體流向冷媒; − = 冷媒加熱此固體)',
    tooltipCoolantIn: '入口',
    tooltipCoolantOut: '出口',
    tooltipCoolantDelta: '冷媒 ΔT。以絕對值顯示,符號慣例因模板而異。',
  },
  deltaTable: {
    baselineLabel: '基準:',
    dp: 'DP',
    needsMultipleDps:
      '差異表需要至少兩個完成設計點; 只對一個 DP 比較不是零就是自身。',
    caption_one: '{{count}} 個 DP 比較 · 儲存格顯示相對基準的絕對 Δ (百分比 Δ)',
    caption_other:
      '{{count}} 個 DP 比較 · 儲存格顯示相對基準的絕對 Δ (百分比 Δ)',
  },
  dpTable: {
    dp: 'DP',
    verdict: '判定',
    empty: '尚無包含結果摘要的完成設計點。',
    caption_one:
      '{{count}} 個設計點 · 點擊表頭排序 · 判定依執行狀態、收斂與質量守恆而定',
    caption_other:
      '{{count}} 個設計點 · 點擊表頭排序 · 判定依執行狀態、收斂與質量守恆而定',
    verdicts: {
      pass: '通過',
      warn: '需檢查',
      fail: '未通過',
      stopped: '已停止',
      notEvaluated: '未評估',
    },
    verdictReasons: {
      stopped:
        '執行在 {{iters}} 次疊代後停止，尚未確認收斂。儲存數值是部分結果，並非發散判定。',
      pass: '求解器已收斂,質量守恆在 1% 以內。',
      fail: '求解器未收斂。最差殘差 {{eq}} = {{value}}，相對於其 {{target}} 目標為 {{factor}} 倍，發生在 {{iters}} 次疊代之後。',
      failNoTarget:
        '求解器未收斂。{{iters}} 次疊代後最差殘差為 {{eq}} = {{value}}。此執行未帶殘差目標，因此超出基準多少並不在回傳資料中。',
      failSplitTarget:
        '求解器未收斂。{{iters}} 次疊代後殘差為 {{eq}} = {{value}}。流體與固體區域為它設定了不同的目標，而這次執行只為兩個區域回報一個殘差，因此不與任一目標比較。',
      failNoResiduals:
        '求解器未收斂，且未回報各方程式的殘差，因此只知道疊代次數: {{iters}}。',
      warn: '求解器已收斂，但質量不平衡為 {{pct}} %，相對於 {{bar}} % 基準為 {{factor}} 倍。域尚未完全封閉。',
      notEvaluated: '判定信號不足; 未輸出收斂或質量守恆欄位。',
      noSignals: '此設計點尚無結果摘要; 執行完成後判定會填入。',
    },
  },
  verification: {
    evidence: {
      wallBufferFails:
        '壁面面積的 {{frac}}% 落在 y⁺ 5–30 緩衝帶，兩種壁面處理都不適用（上限 {{limit}}%）— 此執行的摩擦力數值不可採信',
      wallBufferPassesCaveat:
        '壁面面積的 {{frac}}% 落在 y⁺ 5–30 緩衝帶 — 可接受，但任何摩擦力主張都帶有此保留',
      wallBufferPasses: '壁面面積的 {{frac}}% 落在 y⁺ 5–30 緩衝帶',
      flowTypeMismatch:
        '{{template}} 範本正在 {{mesh}} 網格上執行 — 就算算得對，答的仍是錯的問題',
      stagnationFails:
        '壁面峰值壓力為動壓的 {{ratio}} 倍，預期為 {{expected}} — 壓力場與宣告的流動條件不一致',
      stagnationPasses:
        '壁面峰值壓力為動壓的 {{ratio}} 倍，在預期 {{expected}} 的 {{tol}}% 以內',
      energyImbalanceFailsWithFlows:
        '能量不平衡 {{imbalance}} J 超出 {{tolerance}} J 容許帶。該容許帶約為最大能量項的 1%，並會在仍有比例 {{fraction}} 的面使用估計（還原梯度）熱率時放寬，再加上 {{absTol}} W × {{period}} s 的小底限。面熱率沿時間積分；估計熱率可能拉開殘差——這指向那些面附近的網格解析，不是守恆定律失效。（輸入能量 {{energyIn}} J，儲能變化 {{deltaE}} J）',
      energyImbalanceFails:
        '能量不平衡 {{imbalance}} J 超出 {{tolerance}} J 容許帶。該容許帶約為最大能量項的 1%，並會在仍有比例 {{fraction}} 的面使用估計（還原梯度）熱率時放寬，再加上 {{absTol}} W × {{period}} s 的小底限。面熱率沿時間積分；估計熱率可能拉開殘差——這指向那些面附近的網格解析，不是守恆定律失效。',
      energyImbalancePassesWithFlows:
        '邊界熱與儲能變化在 {{tolerance}} J 內閉合。面熱率優先由直接量測（反力、施加通量、膜溫）沿時間積分；估計的還原梯度熱率僅作最後手段。（輸入能量 {{energyIn}} J，儲能變化 {{deltaE}} J）',
      energyImbalancePasses:
        '邊界熱與儲能變化在 {{tolerance}} J 內閉合。面熱率優先由直接量測（反力、施加通量、膜溫）沿時間積分；估計的還原梯度熱率僅作最後手段。',
      energyImbalanceUnavailable:
        '此暫態執行未建立積分能量平衡，因此未量測閉合情形。',
      temperatureBoundsFails:
        '溫度離開初始條件與邊界／環境值設定的 [{{lo}}, {{hi}}] K 帶（觀測 [{{obsMin}}, {{obsMax}}] K，容差 {{tol}} K）。請加大第一增分，或在階躍邊界附近加密網格。',
      temperatureBoundsPasses:
        '所有溫度維持在 [{{lo}}, {{hi}}] K 內（±{{tol}} K 輸出雜訊）。',
      boundaryFluxUnresolved:
        '兩個邊界面積分相差 {{imbalance}} W，超過 {{tolerance}} W 容許帶（輸入 {{heatIn}} W，輸出 {{heatOut}} W），因此網格未能解析一或多個 BC 面的溫度梯度，從該處梯度讀出的單面熱率不可靠。請在 BC 面加細邊界層後再依賴這些熱率。溫度與求解本身不受影響——穩態傳導求解依建構守恆能量。',
    },
    cht: {
      coolantMassBalance: '冷卻液質量守恆',
      coolantMassBalanceSub:
        '通過冷卻液區域的 {{flow}} kg/s 中有 {{imbalance}} kg/s。',
      energyClosure: '能量不平衡',
      energySub: '輸入 {{in}} W,移除 {{out}} W。',
      heatIn: '流入 {{value}} W',
      heatOut: '流出 {{value}} W',
      // 收支未閉合但不一定是此次執行的問題的原因。後端以英文送出，
      // 已翻譯的介面改讀這裡。
      explained: {
        notConverged: '尚未確認收斂；此部分能量收支不能證明解已發散',
        limiterClamped:
          '限制器鉗制了網格，這會改寫場但不會改寫由場計算出的通量，因此本就預期偏高',
      },
      energyExplainedBy: '判讀時請注意：{{reasons}}。',
      temperatureTarget: '溫度目標',
      targetSub: '宣告上限 {{limit}} K。',
      interfaceFlux: '傳入冷媒的熱量',
      interfaceFluxSub: '峰值 {{peak}} W/m²(位於 {{patch}})。',
      balance: {
        success: '閉合',
        warning: '偏鬆',
        destructive: '未閉合',
      },
      energy: {
        ok: '閉合',
        warn: '偏鬆',
        fail: '未閉合',
        provisional: '部分結果',
      },
      target: { met: '達成', missed: '未達', notRequested: '未宣告' },
      tooltips: {
        coolantMassBalance:
          '流出減流入,以通過流量的比例表示。執行回報的是絕對 kg/s,此處以比例呈現,好讓它能與 CFD 的質量不平衡套用同一組門檻。超過數個百分點即表示求解未守恆質量,後續任何數值都不可信。',
        energyClosure:
          '這裡比較整個模型控制體積的熱傳速率（W），不是儲存的能量。失衡率 = 100 ×（熱輸入 − 熱輸出）/ 熱輸入。0% 表示相等；+100% 表示沒有回報熱輸出。固體與流體之間的內部熱傳不算對外排熱。未收斂的執行可能尚未平衡。',
        energyProvisional:
          '執行在取得最終解之前停止。未回報出口熱率可能只是輸出不完整；此比例不能證明實際熱量累積或數值發散。',
        heatIn:
          '模型內宣告的熱源功率，包含固體熱源。單位為 W，不是儲存的能量。',
        heatOut:
          '執行回報經外部邊界離開模型的熱傳速率。區域間的內部熱傳不計入。單位為 W。',
        temperatureTarget:
          '最熱固體是否維持在宣告上限之下。這是三態而非兩態 — 未宣告上限並不等於通過,此列會如實說明,而不是顯示一個未經檢核的餘裕。',
        interfaceFlux:
          '固體經由所有流固界面傳給冷媒的淨熱量 (負值: 冷媒正在加熱固體),以及承受最高熱通量密度的面。它是上方能量收支的一側,因此是參考數值而非判定門檻。',
      },
    },
    heading: '驗證',
    subhead: '每個設計點的收斂、質量守恆、湍流與力分解訊號。',
    noneAvailable: '尚無設計點完成執行。至少一次執行完成後,驗證訊號才會出現。',
    designPoint: 'DP {{id}}',
    notEvaluated: '未評估',
    convergence: '收斂',
    converged: '已收斂',
    convergedAtIterationLimit: '已收斂（未發散），達到迭代上限',
    notConverged: '未收斂',
    itersLabel: '({{used}}{{max}} 迭代)',
    exitReasonLabel: '停止原因',
    exitReason: {
      converged: '所有方程式都達到目標',
      iterationLimit: '達到迭代上限',
      timeLimit: '時間用盡',
    },
    stopLimit: {
      iterationLimit: '已停止：達到迭代上限',
      timeLimit: '已停止：達到時間上限',
    },
    exitReasonTimeSub:
      '結束這次執行的是時間限制,而不是殘差,因此這本身並不代表設定有問題。',
    regionFluid: '流體',
    regionSolid: '固體',
    regionTargetsNote:
      '流體與固體區域為 {{equations}} 設定了不同的目標。這次執行只為兩個區域回報一個殘差,因此不與任一目標比較。',
    hitIterLimit: '達到迭代上限',
    silentPassSuspect: '已達目標仍跑到迭代上限',
    terminatingCriterion: '終止準則',
    cumulativeContinuity: '累積連續性誤差',
    massImbalance: '質量不平衡',
    percentile: '百分位',
    residualsHeading: '殘差',
    residualImbalanceRelation: {
      title: '此不平衡如何計算',
      stepLabel: '步驟 {{position}}／{{total}}',
      energyHeading: '能量不平衡（來自邊界熱流率）',
      energyEquationAria: 'ε_E 等於 100 乘以 (Q_in 減 Q_out) 再除以 Q_in',
      energyPluggedAria:
        '{{pct}} 百分比等於 100 乘以 ({{in}} 減 {{out}}) 再除以 {{in}} 瓦',
      energyScopeNote: 'Q_in 與 Q_out 是整個模型外邊界熱流率的總和。',
      varQinMeaning: '外邊界進入的熱量',
      varQoutMeaning: '外邊界離開的熱量',
      varEpsilonEMeaning: '由上述總和算出的能量不平衡',
      interfaceNotInFormula:
        '經由介面傳入冷媒的熱量（{{value}} W）另行列出。ε_E 只用 Q_in 與 Q_out。',
      massHeading: '質量不平衡（來自冷卻劑通量）',
      massHeadingFlow: '質量不平衡（來自入口與出口流量）',
      massStepImbalanceAria: 'ṁ_imbalance 等於 ṁ_in 加 ṁ_out',
      massStepImbalanceNote:
        '冷卻劑入口與出口的有號質量流率加總。流入為負、流出為正；兩者之和即邊界上的淨質量不平衡。',
      massStepImbalanceNoteFlow:
        '入口與出口的有號質量流率加總。流入為負、流出為正；兩者之和即淨質量不平衡。',
      massStepRefAria: 'ṁ_ref 等於 |ṁ_in| 與 |ṁ_out| 中較大者',
      massStepRefNote:
        '參考流量取入口與出口流量絕對值中較大者。若出口完全沒有回報流量，不平衡為 100%，而非無法定義。',
      massEquationAria: 'ε_m 等於 |ṁ_imbalance| 除以 ṁ_ref',
      massStepFracNote:
        '相對不平衡：邊界上的淨流量佔入口與出口流量中較大者的比例。它由邊界流量算出，而非由殘差算出。',
      massPluggedAria:
        '{{pct}} 百分比等於 |{{imbalance}}| 除以 {{flow}} 公斤每秒',
      massPluggedFrac: '佔較大流量的 {{pct}} %',
      massScopeNote: 'ṁ_imbalance 與 ṁ_ref 來自流體區域的冷卻劑入口與出口。',
      massScopeNoteFlow: 'ṁ_imbalance 與 ṁ_ref 來自流動區域的入口與出口開口。',
      varMInMeaning: '入口冷卻劑質量流率（流入為負）',
      varMOutMeaning: '出口冷卻劑質量流率（流出為正）',
      varMImbalanceMeaning: '冷卻劑淨質量不平衡（ṁ_in + ṁ_out）',
      varMRefMeaning:
        '冷卻劑入口與出口質量流率中較大者（max(|ṁ_in|, |ṁ_out|)）',
      varEpsilonMMeaning: '相對於較大流量的質量不平衡比例',
      linkHeading: '最後一次迭代殘差：另一項指標',
      linkNote:
        '殘差衡量解在每個網格中穩定的程度。上方的不平衡是由邊界上的流量算出，而非由殘差算出，因此不平衡接近零、殘差卻高於目標是常見的情況。請分開解讀兩者。',
      askAssistantAgent: 'Agent',
      askAssistant: '問助理此次執行中殘差 (h) 與 ε_E 的關係',
      askAssistantLabel: '請助理說明此次執行中殘差 (h) 與這個能量不平衡的關係',
      askAssistantTitle: 'ε_E 與殘差 (h)',
      askAssistantNoTarget: '未記錄',
      askAssistantPrompt:
        '此設計點上 residual(h) 為 {{residual}}（收斂退出目標 {{target}}）。進入熱量 {{qin}} W、離開熱量 {{qout}} W，所以 ε_E 為 {{pct}} %。殘差衡量能量解穩定的程度；ε_E 是由邊界熱量總和算出，而非由殘差算出。此次執行中兩者的關係為何，是否有任何一項讓人懷疑結果？不要假設兩者必須一致。請用白話回答；不要使用工具名稱或配線欄位路徑。\n\n僅供你的工具使用、請勿向我複述：研究 {{studyId}}、設計點 {{dpId}}。',
      linkEnergyLabel: '能量',
      linkMassLabel: '質量／連續性',
      linkResidualVsTarget: '殘差 {{residual}}，收斂退出目標 {{target}}',
      linkResidualNoTarget: '殘差 {{residual}}，未記錄收斂退出目標',
    },
    relaxation: '鬆弛係數',
    relaxationTooltip:
      '此執行提交的鬆弛係數（0–1）。數值越小，欄位更新越保守。— 表示未回報此設定。',
    residualTooltips: {
      U: '速度方程式。',
      p: '壓力方程式。',
      p_rgh: '經重力修正的壓力，用於維持質量流率平衡。',
      h: '流體或固體的能量方程式。',
      T: '溫度方程式。',
      k: '紊流動能方程式。',
      omega: '紊流比耗散率方程式。',
      epsilon: '紊流耗散率方程式。',
      other: '{{equation}} 方程式的殘差。',
    },
    equation: '方程式',
    final: '最終',
    residual: '初始殘差',
    target: '目標',
    overTarget: '超過目標',
    noResiduals: '無殘差資料。',
    boundingHeading: '界限事件',
    field: '欄位',
    count: '次數',
    firstIter: '首次迭代',
    maxMagnitude: '最大幅度',
    forcesHeading: '力; 壓力 / 黏性分解',
    forcesCaption:
      '壓力 = 法向牽引力(形狀阻力主因)。黏性 = 切向牽引力(摩擦阻力)。切勿相加; 相互抵消的兩個大誤差可能被合計掩蓋。',
    axis: '軸',
    pressureN: '壓力 ({{unit}})',
    viscousN: '黏性 ({{unit}})',
    coefficientsHeading: '力係數',
    lOverD: 'L / D',
    copFracLref: 'CoP 位置 (l_ref)',
    copSuppressed: '已抑制 (|C_L| < 1e-3)',
    refGeometry: 'A_ref = {{area}} · l_ref = {{chord}}',
    yPlusHeading: '壁面 y⁺',
    yPlusMin: '最小',
    yPlusMean: '平均',
    yPlusMax: '最大',
    yPlusFracBelow5: 'y+ <5 面積比',
    yPlusFrac5To30: 'y+ 5–30 面積比',
    yPlusFrac30To100: 'y+ 30–100 面積比',
    yPlusFracAbove100: 'y+ >100 面積比',
    yPlusBandsPending:
      '面積比帶(<5 / 5–30 / 30–100 / >100)開發中; 僅靠最小/平均/最大可能掩蓋邊界層覆蓋率問題。',
    externalDomainHeading: '外域與阻塞',
    blockageRatio: '阻塞比',
    domainExtentsX: 'X 方向延伸 (本體直徑倍數)',
    domainExtentsY: 'Y 方向延伸 (本體直徑倍數)',
    domainExtentsZ: 'Z 方向延伸 (本體直徑倍數)',
    externalDomainPending:
      '阻塞比與各軸延伸開發中; 從熟悉的 0.55% 上升到 2.18% 現在無處呈現。',
    freestreamHeading: '自由流湍流',
    freestreamNutOverNu: 'ν_t / ν (自由流)',
    turbulenceIntensity: '湍流強度',
    turbulentLengthScale: '湍流長度尺度',
    freestreamPending:
      '入口導出 ν_t / ν 開發中; 使用者宣告強度與長度尺度,但沒人計算比值,因此 5 500× 可能以看似合理的 10 通過所有檢查。',
    tooltips: {
      convergence:
        '求解器是否在迭代預算內達到殘差控制。「未收斂」表示執行耗盡預算; 以下數值仍是求解器輸出,但您看到的是未穩定的場,而非已收斂的解。',
      terminatingCriterion:
        '求解器停止迭代的原因; 達到殘差控制、耗盡迭代預算、或求解器端中止。',
      exitReason:
        '穩態計算會以三種方式之一停止:所有方程式都達到目標、達到迭代上限,或時間用盡。只有第一種算是收斂。',
      cumulativeContinuity:
        '整個執行累積的質量通量不平衡。穩態解應趨近於零;單調上升代表壓力場作為虛假質量源。sparkline 顯示軌跡,可一眼區分平坦/衰減與增長。',
      massImbalance:
        '未從出口流出(或逆流)的入口流量比例。外部流因邊界條件不匹配可為非零,但內部流超過 ~1% 通常代表迴路未閉合。',
      nutRatio:
        '整個域的湍流黏度比(ν_t / ν)百分位。若 P50 低於 1,湍流模型幾乎沒有貢獻; 標記為 SST 的層流解。對數律區間約 ~10 至數百。',
      cd: '無因次阻力係數; 流向總力除以 ½ρV²A_ref。符號慣例:順流為正。',
      cl: '無因次升力係數; 橫流方向總力除以 ½ρV²A_ref。',
      cmPitch:
        '參考點周圍的俯仰力矩係數(翼型通常為四分之一弦點)。符號依 study 設定。',
      lOverD: '升阻比 C_L / C_D。越高越有效率。',
      copFracLref:
        '沿 l_ref 的壓力中心位置,以 C_M,pitch / C_L 計算。|C_L| 接近零時無意義; 面板在 1e-3 以下抑制,避免顯示看似合理的雜訊。',
      yPlusMin:
        '物體表面壁 y⁺ 最小值。低於 5 屬於黏性次層;壁函數不適用,對數律外推的剪應力/熱通量不可靠。',
      yPlusMean:
        '面積加權平均壁 y⁺。實用參考,但掩蓋了壁的多少部分位於黏性次層或外對數律區。',
      yPlusMax:
        '壁 y⁺ 最大值。超過 ~300 已超出對數律有效範圍;近壁網格太粗,無法正確解析剪應力。',
      pressureDrop:
        '橫跨區域的物理壓降 p_in − p_out(Pa)。驅動入口通道為正;負值代表壓力上升(突擴、擴散器或反向 BC)。',
      pressureDropKinematic:
        '運動壓降(m²/s²);求解器內部保存的值,即 Δp / ρ。乘以 ρ 得物理 Pa。',
      inletFlowRate:
        '入口體積流量(m³/s)。求解器慣例:入口為負(流入方向與外向面法線相反)、出口為正; |Q_in| = |Q_out| 是質量守恆檢查。',
      outletFlowRate:
        '出口體積流量(m³/s),驅動入口通道為正。與 |Q_in| 比較做質量守恆檢查。',
      portVelocity:
        '入口/出口面片的面積加權平均速度(m/s)。定密度解中兩者偏離代表質量不平衡或埠面積不匹配。',
      wallPressureRange:
        '壁壓極值(Pa);檢查虛假源或 BC 端問題的簡便健全性檢查。將範圍與 ρU²/2 比較,可判斷壁面是否做合理功。',
      yPlusFracBelow5:
        '位於黏性次層 (y+ < 5) 的壁面積比例。壁函數不成立,對數律外推的剪應力/熱通量不可靠;比例過大即為警訊。',
      yPlusFrac5To30:
        '緩衝層 (y+ 5–30) 的壁面積比例。既非黏性次層也非對數律,結果不可預測,此比例應盡量小。',
      yPlusFrac30To100:
        '對數律區 (y+ 30–100) 的壁面積比例。壁函數型湍流模型的原始設計範圍,比例越高越好。',
      yPlusFracAbove100:
        '超出對數律有效範圍 (y+ > 100) 的壁面積比例。近壁網格太粗,剪應力不可信。',
      blockageRatio:
        '本體正面投影面積除以相同位置的外域截面積。超過 ~5% 阻塞效應會改變本體周圍流場,與自由流參考的比較不再公平。',
      domainExtents:
        '從本體到外邊界的延伸,以本體直徑倍數表示。讀者原本需從外域設定與本體包圍盒推導的「夠遠」指標。',
      freestreamNutOverNu:
        '入口導出湍流黏度比,由宣告的湍流強度與長度尺度計算。航太風洞現實值約 10,內部流可達數百;接近 1 000+ 代表入口已充分湍流化。',
      turbulenceIntensity:
        '入口邊界條件宣告的湍流強度。航太風洞 0.1–1%,工業流 5–10%。為輸入值非量測; 保留以供派生 ν_t / ν 追溯。',
      turbulentLengthScale:
        '入口邊界條件宣告的湍流長度尺度; 通常為水力直徑或本體代表尺寸的一部分。保留以供派生 ν_t / ν 追溯。',
      portArea:
        '入口/出口面的截面積 (m²)。與設計對照時,4× 埠面積不匹配會以「非預期的質量收支」而非「求解損壞」現身。',
      reversedFlowFrac:
        '流動進入區域(回流)的出口面積比例。面積加權出口速度因符號相消掩蓋回流; 此逐面通量正負分解是揭露的指標。',
      stagnantVolumeFrac:
        '|U| 低於固定門檻的域體積比例。高值(HX 案例達 92%)代表工作流體未到達大部分幾何; 此執行「成功」但沒做任何事。',
      deadEndVolumeFrac:
        '幾何死路(無流通路徑)的域體積比例。由網格連通性計算而非流場本身,發散執行也有效。',
      disconnectedVolumeFrac:
        '與任何入口或出口都無路徑相連的網格體積比例 — 流動永遠到不了的流體,多半是網格器封住的空隙而非零件本身的特徵。僅由網格判讀,發散執行也有效。流動仍進得去的死路不計入此列(見死路該行)。',
      hydraulicDiameter:
        '入口水力直徑 D_h = 4·A/P,A 為流動面積、P 為浸潤周長。所有內部流雷諾數的基礎長度尺度,以可追溯形式呈現。',
      reynolds:
        '入口雷諾數 Re = ρ U D_h / μ,導出值。目前不在導線上; 應與入口邊界條件並列以讓入口條件可追溯。',
    },
    internalFlowHeading: '內部流訊號',
    pressureDropKinematic: 'Δp / ρ',
    wallPressureRange: '壁壓(最小 / 最大)',
    reversedFlowFrac: '各出口回流比',
    stagnantVolumeFrac: '停滯體積比',
    deadEndVolumeFrac: '死路體積比',
    disconnectedVolumeFrac: '封閉體積比',
    reynolds: '雷諾數',
    internalFlowExtendedPending:
      '死路體積(流動進得去卻通不過的盡頭)仍在開發中。該行留空不等於「沒有死路」。',
  },
  handCalc: {
    scopes: {
      sectionHeading: '區域範圍',
      unavailableCount: '此處有 {{count}} 項不適用',
      noneValid: '此次執行所計算的關係式中，沒有適用於此範圍的項目。',
      runReports: '執行回報值',
      waitingOn: '尚缺',
      facts: {
        declaredPower: '宣告值',
        interfacePower: '通過界面',
        massFlow: 'ṁ',
        coolantRise: 'ΔT',
        pressureDrop: 'Δp',
        patchFlux: '熱通量',
        wettedArea: 'A_wet',
        volume: '體積',
        peakTemperature: 'T 峰值',
        patchSum: '各面加總',
        peakFlux: '最大熱通量',
        patchGap: '分項差',
        fluxDensity: 'Q̇/A_wet',
        shareOfTotal: '佔回報總量',
        spread: '內部溫差',
        interfaceDeltaT: 'ΔT（區域平均）',
        overallCoefficient: 'K = Q̇/(A·ΔT)',
        meanTemperature: 'T 平均',
        peakVelocity: 'U 峰值',
        resistance: 'R',
        closure: '收支差',
      },
      resolvedFrom:
        '取自 {{region}} 區域（材料 {{material}}）。上方假設欄為整體案例值，此範圍讀取自身的值。',
      energyFlow: '熱路徑',
      reversedPatches_one: '{{count}} 個界面的熱流方向相反 — 流入固體。',
      reversedPatches_other: '{{count}} 個界面的熱流方向相反 — 流入固體。',
      conductionUnavailable:
        '此次執行未包含固體之間的熱傳導。固體與固體的接觸皆未量測，因此僅接觸冷卻液的固體只會畫出那一條帶。',
      nodeTemperatures: 'T 最小 / 平均 / 最大',
      tempStops: { min: '最小', avg: '平均', max: '最大' },
      nodeIn: '流入',
      nodeOut: '流出',
      kMissing: {
        noArea: 'K 需要濕潤面積，但此次執行未回報',
        noGradient: 'K 需要溫度梯度 — 兩側溫度相同',
      },
      railLabel: '手算範圍',
      heading: '範圍',
      filed: '已登錄 {{count}} 項',
      wholeModel: '整體模型',
      noScopes: '此次執行未回報可登錄手算的範圍。',
      kinds: {
        case: '案例',
        fluid: '流體',
        solid: '固體',
        iface: '界面',
      },
      kindPlural: {
        case: '案例',
        fluid: '個流體區域',
        solid: '個固體區域',
        iface: '個界面',
      },
      kindWords: {
        case: '整體案例',
        fluid: '流體區域',
        solid: '固體區域',
        iface: '界面',
      },
      ifaceNote:
        '界面來自兩個區域相接，並非手動建立。對流關係式需要一側為流體，因此在固體與固體的接觸上會被拒絕；該處適用的是傅立葉導熱。',
      openAdd: '新增關係式',
      addDialogLabel: '{{where}} 可使用的關係式',
      closeAdd: '關閉',
      addAction: '新增',
      validOn: '在{{where}}有效',
      validNote: '此處適用 {{total}} 項中的 {{valid}} 項',
      allFiled: '此範圍所有有效的關係式都已登錄。',
      backsolveTag: '反算',
      // 顯示在標籤上。說明這一列在求什麼，以及旁邊的式子要反向讀。
      // 這正是它與一般關係式的唯一差別，也決定了空值代表什麼。
      backsolveTagTooltip:
        '反向求解。輸入你需要的目標值，這一列會把旁邊的式子反轉，回推出達到該目標所需的 {{name}}。結果為空表示尚未輸入目標值，而不是此次執行沒有回報這個數字。',
      // 位於選單標題下方，只要清單中有任一反算列就顯示。標籤的提示無法用鍵盤
      // 到達（它在列的按鈕內），因此以這一行把同樣的資訊給那位讀者。
      backsolveLegend:
        '反算列會把式子反向使用: 你輸入目標值，它回推出達成該目標所需的輸入值。',
      soleRegion: '僅 {{kind}}',
      unavailable: '此處不適用',
      unavailableHint: '一律附上原因，不會無聲省略',
      emptyFiled: '此範圍尚未登錄任何項目。新增關係式即可在此計算。',
      remove: '從此範圍移除',
      removeNamed: '將 {{name}} 從此範圍移除',
      reasons: {
        needsFluid: '需要流動 — 請登錄在流體區域',
        needsSolid: '需要實體 — 請登錄在固體區域',
        needsWettedWall: '需要與壁面接觸的流體 — 此接觸為固體對固體',
        needsWall: '需要壁面 — 請登錄在界面',
        needsWholeCase: '橫跨整條路徑 — 請登錄在整體模型',
        ambiguous: '在 {{count}} {{kind}}間無法判定 — 請登錄在其中一個',
      },
    },
    relations: {
      resultUnitLabel: '結果單位',
      feaInputs: {
        heading: '假設值',
        derivedHeading: '關係式',
        resetLabel: '重設假設值',
        resetTooltip: '還原所有由執行結果與材料庫帶入的值。',
        tooltips: {
          volume:
            '此次執行所回報的零件體積。對於在此欄位發佈前的執行，會以 m / ρ 代替，而那只對單一材料零件精確 — 求解器依每個本體的密度累加質量，因此組件上不存在可逆算的單一 ρ。如已知體積可直接覆寫。',
          area: '有效截面積 — 由體積除以長度反求而得,並非量測值。若已知實際截面,可直接覆寫。',
          fibre: '中性軸到最外緣的距離。以圓形截面為初始值,可依實際截面覆寫。',
          inertia:
            '截面二次矩。以圓形截面 A²/4π 為初始值(方形截面則為 A²/12)。請勿由 radius_of_gyration 反推 — 那是以質量為基礎且受長度主導,並非截面的抗彎量。',
          mass: '此次執行自身的質量(result_summary.mass_kg)。作為體積的種子,並經由體積帶出下方所有截面量。',
          length:
            '最長跨距。規格中取自網格邊界框,本面板不會擷取,請自行輸入以解鎖下方的計算鏈。',
          load: '作用載重總計 — 對此次執行的力邊界條件加總其大小。模態或熱傳導執行不會宣告載重,此欄會保持空白。',
          density:
            '密度,取自此次執行所宣告材料的材料庫項目。可覆寫以試算其他合金,無須重跑。',
          e: '楊氏模數,取自同一材料庫項目。',
          yieldStrength: '降伏強度,取自同一材料庫項目。安全係數即以此為基準。',
        },
      },
      scope: {
        fea: '結構 · FEA',
        cht: '共軛熱傳 · CHT',
        external: '外部流 · CFD',
        internal: '內部流 · CFD',
      },
      names: {
        fea: {
          volume: '體積',
          length: '特徵長度',
          area: '有效截面積',
          fibre: '最外緣距離',
          inertia: '截面二次矩',
          axialStress: '軸向應力',
          bendingStress: '彎曲應力',
          deflection: '撓度',
          extension: '軸向伸長',
          fos: '安全係數',
          buckling: '歐拉挫屈載重',
          frequency: '一階固有頻率',
          slenderness: '細長比',
          eulerEndFixity: '歐拉端末拘束係數',
          cantilever: '懸臂',
          simplySupported: '簡支',
          fixedFixed: '兩端固定',
          pinnedPinned: '兩端鉸接',
          fixedFree: '一端固定一端自由',
          beamBending: '樑彎曲',
          axialRod: '軸向桿',
        },
        dynamicPressure: '動壓',
        reynolds: '雷諾數',
        skinFriction: '摩擦係數',
        frictionVelocity: '摩擦速度',
        firstCellHeight: '第一層網格高度',
        backSolvedCd: '求解器 C_D',
        handDrag: '手算阻力',
        backSolvedCl: '求解器 C_L',
        handLift: '手算升力',
        refAreaFromCd: '由 C_D 反求 A_ref',
        refAreaFromCl: '由 C_L 反求 A_ref',
      },
      validity: {
        cantilever: '一端固定,自由端受載',
        simplySupported: '兩端鉸接,中央受載',
        fixedFixed: '兩端剛接',
        pinnedPinned: '兩端鉸接 — 基準情況',
        fixedFree: '一端剛接,另一端自由',
        beamBending: '細長、彎曲主導',
        axialRod: '短粗、縱向模態',
      },
      aria: {
        dynamicPressure: 'q 等於二分之一 rho 乘以 U inlet 平方',
        reynolds: '雷諾數等於 U inlet 乘以 L 除以 nu',
      },
      notes: {
        feaBendingMoment:
          '對應在撓度關係式所選支承條件的最大彎矩 — 懸臂固定端為 F·L,簡支跨中央為 F·L/4。',
        feaFos: '對應主導應力 — 有彎曲時取彎曲,否則取軸向。',
        feaBuckling: '僅適用受壓的細長構件。比較餘裕 P_cr / F。',
        feaFrequency: '樑是 3D 零件的粗略模型,應預期數量級相符而非精確吻合。',
        feaSlenderness: 'λ 大表示彎曲與挫屈主導;λ 小表示塊體或軸向行為主導。',
        skinFriction: '平板紊流關聯式。在強壓力梯度或分離尾流之後會低估。',
        backSolved:
          '由此次執行自身的力反求而得,是求解器的回報值,並非用來檢核它的基準。',
        backSolvedArea:
          '由求解器的力與您輸入的係數反求 — 可用來檢核執行所宣告的參考面積。',
      },
      indexLabel: '此手算的關係式',
      count_one: '{{count}} 個關係式',
      count_other: '{{count}} 個關係式',
      given: '已知量',
      result: '結果',
      references: '對照對象',
      referencesShort: '下方有參考式',
      referenceOutOfRange:
        '在本次運算的 Re 與 Pr 下,此式已超出適用範圍。顯示是為了讓你看見它不適用,不可引用。',
      referencesHint:
        '已發表的公式(唯讀)。請自行套用符合本案例的一式,並與上方結果比較;本面板不會代為計算。',
      noCounterpartShort: '理想化步驟',
      resultUnavailable:
        '輸入皆已齊備,但其中有值超出本關係式的適用範圍,因此無法計算。',
      runFigureMissing:
        '此次執行未回報此步驟所需的某個數值，因此無從代入。這不是上方欄位可以填補的。',
      dimensionlessSuffix:
        '{{symbol}} — 無因次量，因此此欄位輸入純數值、不帶單位。比值請以小數輸入；也接受 `1%`，會存為 0.01。',
      fromEarlierStep:
        '由本推導中較前的步驟產生，因此此處沒有可填欄位 — 補齊該步驟後此值即會跟著出現。破折號代表該步驟尚無法計算。',
      fromEarlierStepTag: '↑ 前一步',
      substituteBlocked: '上方輸入不足,此步驟無法計算。',
      pickOne: '關聯式 · 擇一',
      comparesTo: '對照 {{key}}',
      noCounterpart: '理想化步驟 — 無對照對象',
      empty: '此範本尚無手算關係式。',
    },
    heading: '手算沙盒',
    subhead:
      '輸入您預期執行應落在的參考值。欄位由求解器入口 BC + 流體預設 + 參考幾何自動填入;編輯任一值可查看導出量如何變化。',
    dpSelectorLabel: '參考設計點',
    dpItem: 'DP #{{index}} · {{label}}',
    resetLabel: '重設為提交值',
    resetTooltip:
      '將所有欄位重設為執行提交時的值:求解器入口 BC、流體預設、力係數參考面積/翼弦,以及內部流執行時的網格導出入口面積。單位捕捉回 SI,使數值欄位與案例實際執行的值一致。編輯後的值在切換設計點時會保留;按此按鈕會重新同步至目前研究的提交值。',
    assumptions: '假設',
    target: '目標',
    expected: '預期',
    firstLayer: '首層高度',
    derivedHeading: '導出',
    shapePresetLabel: '由典型形狀預填 {{coefficient}}',
    shapePresetTitle: {
      cd: '典型 C_D 值',
      cl: '典型 C_L 值',
    },
    shapePresetSubtitle: '點擊列即預填',
    shapePreset: {
      sphereSmooth: '球體（光滑） (Sphere smooth)',
      sphereSmoothRegime: '超臨界 Re (C_D 急降後), Re > 4×10⁵',
      sphereRough: '球體（粗糙） (Sphere rough)',
      sphereRoughRegime: '高爾夫球, 邊界層觸發',
      cube: '立方體 (Cube)',
      cubeRegime: '流向與面平行, Re > 10⁴',
      flatPlatePerp: '平板（垂直） (Flat plate perpendicular)',
      flatPlatePerpRegime: '鈍體上限',
      cylinderLong: '長圓柱（橫流） (Long cylinder)',
      cylinderLongRegime: '長寬比 > 10, 亞臨界 Re',
      streamlinedHalfBody: '流線半體 (Streamlined half-body)',
      streamlinedHalfBodyRegime: '圓鼻尖尾',
      streamlinedBody: '流線體（魚型） (Streamlined body)',
      streamlinedBodyRegime: '長細比 4:1, 附著邊界層',
      teardropAxisym: '軸對稱淚滴 (Axisymmetric teardrop)',
      teardropAxisymRegime: '理想流線形, Re > 10⁵',
      sedanTypical: '轎車 (Passenger sedan)',
      sedanTypicalRegime: '2010 後量產車',
      sportsCar: '跑車 (Sports car)',
      sportsCarRegime: '低引擎蓋量產雙門跑車',
      suvTypical: 'SUV / 跨界',
      suvTypicalRegime: '方型量產 SUV',
      semiTruck: '半掛卡車 (Semi-truck)',
      semiTruckRegime: '8 級牽引車 + 拖車',
      naca0012_0deg: 'NACA 0012 翼型, α = 0°',
      naca0012_0degRegime: '對稱, 無升力, Re ~5×10⁶',
      naca0012_10deg: 'NACA 0012 翼型, α = 10°',
      naca0012_10degRegime: '接近失速, Re ~5×10⁶',
      naca2412_0deg: 'NACA 2412 翼型, α = 0°',
      naca2412_0degRegime: '有彎度, 零迎角有正升力',
      naca2412_10deg: 'NACA 2412 翼型, α = 10°',
      naca2412_10degRegime: '遠低於失速, Re ~5×10⁶',
      flatPlateThinAoA5: '薄平板, α = 5° (Thin flat plate)',
      flatPlateThinAoA5Regime: '薄翼理論: C_L ≈ 2π·α (rad)',
    },
    dynamicPressure: 'q = ½ρU²',
    backSolvedCd: '由求解器阻力反解 C_D',
    backSolvedShort: '由求解器阻力反解',
    expectedDrag: '由 C_D 預期阻力 D',
    expectedFromCd: '由 C_D 預期',
    tooltips: {
      rho: '流體密度(kg/m³)。從求解器流體預設或明確密度覆寫填入。1.204 = 20°C 空氣,998 = 20°C 水。',
      nu: '運動黏度 ν = μ/ρ(m²/s)。從求解器流體預設或明確黏度覆寫填入。用於 Re 及 y⁺ 相關。',
      velocity:
        '自由流/入口速度大小 U∞(m/s)。從求解器入口 BC 填入,備援為報告的入口平均速度。',
      refArea:
        'C_D / C_L 使用的參考面積 A_ref(m²)。從求解器力係數參考面積填入; 這是求解器實際除以的值。變更此值會反解在不同 A_ref 下求解器應該報告的係數。',
      refChord:
        '參考長度 l_ref(m)。此處也作為 y⁺ / 邊界層 Re 的平板長度。翼型為弦長,鈍體為順流延伸。',
      yPlus:
        '第一層網格的目標無因次壁距。低雷諾數壁面解析模型用 1,壁函數用 30–100。面板反解在當前 U∞ 與 l_ref 下,可將 y⁺ 帶到此目標的首層高度。',
      handCd:
        '預期阻力係數; 來自風洞量測、Cd–Re 相關或目標值。輸入後啟用下方摘要表的阻力比較列。',
      handCl:
        '預期升力係數; 與 C_D 相同的風洞/相關/目標來源。輸入後啟用對求解器 Y 軸力積分的升力比較列。',
      inletArea:
        '入口截面積 A_in(m²)。內部流時,此值透過埠水力直徑驅動 Re = ρU·D_h/μ,而非物體參考面積。可從網格預檢自動填入。',
      hydraulicDiameter:
        '入口埠的水力直徑 D_h = 4·V / A(m)。圓管即為直徑;矩形管道為 2·a·b / (a+b)。內部流時取代翼弦作為 Re 的長度尺度。',
      derivedQ:
        '動壓 q = ½ρU²(Pa)。皮托管在停滯流線讀到的總壓減靜壓。所有力/壓力係數的正規化因子。',
      derivedRe:
        '雷諾數 Re = U·L/ν = ρ·U·L/μ。慣性力與黏性力之比。下方 1/7 冪次律 Cf 相關對光滑亂流邊界層有效,約 5×10⁵ < Re < 10⁷;超出範圍會低估摩擦係數。',
      derivedCf:
        '摩擦係數 Cf = 0.026·Re^(−1/7)。平板亂流 BL 的 1/7 冪次律相關; Re ~ 10⁶ 的外部空氣動力學價廉合理。不適用於層流(Blasius)、管流(用 Moody / Colebrook)、粗糙面主導表面。',
      derivedUTau:
        '摩擦速度 uτ = U·√(Cf/2) = √(τ_wall / ρ)(m/s)。設定近壁速度尺度。與 ν 結合決定 y⁺ = y·uτ/ν,固定任何目標 y⁺ 的首層高度。',
      derivedY0:
        '第一格壁法線高度 y₀ = y⁺·ν / uτ(此處轉為 mm)。輸入目標 y⁺,得到讓對數律(或壁面解析模型)落在應在位置所需的首層高度。',
      derivedBackCd:
        'C_D = D / (½ρU²·A_ref)。阻力定義的逆算:給定 X 向求解器阻力與參考面積,回推執行應報告的係數。求解未啟用力係數抽取時有用。',
      derivedExpectedD:
        'D = C_D·½ρU²·A_ref(N)。由預期 C_D 得到的正向阻力。與求解器阻力比較,可判斷偏差在係數或在參考面積。',
      derivedBackCl:
        'C_L = L / (½ρU²·A_ref)。與 C_D 列相同的反解關係,對求解器 Y 軸力。求解未啟用力係數抽取時有用。',
      derivedExpectedL:
        'L = C_L·½ρU²·A_ref(N)。由預期 C_L 得到的正向升力。與求解器 Y 力的 Δ 可判斷偏差在係數或在參考面積。',
      derivedBackARefFromCd:
        'A_ref = D / (½ρU²·C_D)(m²)。上方 A_ref 輸入的正確性檢查:給定求解器 X 向阻力與您的預期 C_D,兩者一致時應對應的參考面積。與您輸入的 A_ref 比較; 最常見的誤配置是 1 m² 預設回退悄悄進入求解器。僅在 C_D 與求解器阻力均可用時顯示。',
      derivedBackARefFromCl:
        'A_ref = L / (½ρU²·C_L)(m²)。與 C_D 列相同的健全檢查,針對求解器 Y 力與您的預期 C_L。僅在 C_L 與求解器升力均可用時顯示。',
    },
  },
  summary: {
    heading: '求解器一致性檢查',
    subhead:
      '算術恆等式與平板相關; 這是一致性,不是準確性。Q = U·A 與 q = ½ρU² 是應在捨入誤差內對齊的恆等式(Δ 非零代表配管錯誤,不是物理)。Cf 與 y₀ 是 1/7 冪次律相關,在分離流/非平板流合理偏差 20–50%。不要將此讀為執行的信心分數; 實際可信度訊號在第 4.2 節驗證。',
    quantity: '量',
    hand: '手算',
    solver: '求解器',
    absDelta: 'Δ',
    pctDelta: 'Δ %',
    dragX: '阻力 X(壓力+黏性,順流)',
    liftY: '升力 Y(壓力+黏性,橫流)',
    dynamicPressure: 'q = ½ρU²',
    caption: '缺少任一側的列顯示「—」表示沙盒尚無值或求解器未輸出該欄位。',
    tooltips: {
      cd: '阻力係數。求解器 = 執行報告的值。手算 = 您輸入的預期 C_D。Δ % 較大時,可能是真實的過度/不足預測,或兩側參考面積 A_ref 不匹配; 檢查上方沙盒的參考面積列。',
      cl: '升力係數。求解器 = 執行報告的值。手算 = 您輸入的預期 C_L。診斷模式與 C_D 相同; Δ 大表示真正的預測差距或 A_ref 不匹配。',
      liftY:
        '橫流方向的力 = 升力軸向的壓力分量 + 黏性分量。求解器 = 執行的 force_pressure_y + force_viscous_y。手算 = 預期 C_L · ½ρU² · 參考面積 A_ref。',
      dragX:
        '順流方向的力 = 流動軸向的壓力分量 + 黏性分量。求解器 = 執行的順流壓力力 + 順流黏性力總和。手算 = 預期 C_D · ½ρU² · 參考面積 A_ref。',
      dynamicPressure:
        '動壓 q = ½ρU²。兩側均由沙盒中相同的 ρ 與自由流速度 U∞ 計算,此列應永遠以 0% 對齊; 非零 Δ 表示兩側讀到不同的密度或速度值。',
      pressureDrop:
        '橫跨通道的物理壓降 Δp = p_in − p_out。求解器 = 執行報告的值。v1 中手算側刻意留空; 目標 Δp 輸入是沙盒的後續工作。',
      pressureDropKinematic:
        '運動壓降 Δp / ρ。求解器內部保存的值;上方物理 Pa 列即此值乘以 ρ。',
      inletFlow:
        '入口體積流量 |Q_in| = |U_in · A_in|。手算 = 沙盒的自由流速度 U∞ · 入口面積 A_in。求解器 = 執行的入口積分流量(依外向面法線帶符號輸出,此處以絕對值比較)。Δ % 接近 0 為質量守恆檢查通過。',
      inletVelocity:
        '入口面片的面積加權平均速度 U_in,avg。手算 = 您輸入的自由流速度 U∞。求解器 = 執行的入口積分速度。兩者偏離代表實際入口面積與沙盒假設不符; 檢查入口面積 A_in。',
    },
  },
  radar: {
    heading: '第一層 · 求解器一致性檢查',
    subhead:
      'V&V 驗證層級的第一層; 手算面板與求解器之間的算術一致性,不是驗證。第二層(代理/DOE)、第三層(驗證)、第四/五層(量測; 風洞/飛行)在其匯入實作後將作為新層疊上,各有各自的容差帶。分數為最差軸,非平均。兩個程式可能一致但都錯,執行可能通過此處所有算術恆等式仍屬非物理; 請視為自我測試,而非可信度判定。',
    pending: '尚未支援',
    emptyNoCompleted: '尚無可對照打分的已完成執行。',
    emptyNoScores:
      '填入上方手算面板後就會開始打分 — 每個填入值的列會成為雷達的一個軸。',
    worstAxisScoreTooltip:
      '0% = 最差計分軸位於容差帶外緣或超出(恆等式 1%、相關 30%)。100% = 所有計分軸在捨入誤差內一致。顯示值為計分軸的最小值,非平均; 單一災難性軸不會被五個好軸平均化。佔位軸(繪為缺口)排除。',
    symbol: '符號',
    identityBand: '恆等式・1% 誤差容限',
    correlationBand: '相關・30% 誤差容限',
    worstAxisScoreCaption: '計分軸分布',
    worstLabel: '最差',
    medianLabel: '中位',
    maxLabel: '最佳',
    hand: '手算',
    solver: '求解器',
    score: '分數',
    placeholderTooltip:
      '此訊號尚未支援。以多邊形上的缺口而非數值繪製,避免缺失軸被讀為通過或失敗。',
    series: {
      selfConsistency: '手算 vs 求解器',
    },
    legendCaption: '設計點',
    legendPinTooltip: '點擊固定; 編輯沙盒時仍保持高亮',
    legendUnpinTooltip: '點擊取消固定',
    symbolAnnotations: {
      pressureViscous: '壓力+黏性',
    },
    axes: {
      cd: '阻力係數',
      cl: '升力係數',
      dragX: '順流阻力',
      liftY: '橫流升力',
      q: '動壓',
      qIn: '入口流量',
      uIn: '入口速度',
      yPlusBands: 'y⁺ 覆蓋率',
      nutRatio: '湍流黏度',
      massBalance: '質量守恆',
      deadVolume: '停滯區比',
      blockage: '阻塞比',
    },
    tooltips: {
      cd: '阻力係數; 求解器 vs 預期。30% 誤差容限:非平板物體上的大幅偏差對平板相關而言為合理物理,不是執行缺陷。',
      cl: '升力係數; 求解器 vs 預期。30% 帶,與 C_D 相同理由。',
      dragX:
        '順流力恆等式; 手算 C_D · ½ρU² · 參考面積 A_ref vs 求解器沿流動軸的壓力+黏性力。嚴格 1% 誤差容限;Δ 表示配管/參考值不匹配。',
      liftY:
        '橫流力恆等式; 手算 C_L · ½ρU² · 參考面積 A_ref vs 求解器沿升力軸的壓力+黏性力。嚴格 1% 誤差容限。',
      q: '動壓恆等式; 兩側均由相同 ρ 與 U 計算 q = ½ρU²。Δ 應在捨入範圍內為零;否則表示兩側讀取不同的輸入。',
      qIn: '入口流量恆等式; 手算 U∞ · 入口面積 A_in vs 求解器入口積分流量。嚴格 1% 誤差容限;Δ 表示入口面積 A_in 不匹配或入口 BC 反向。',
      uIn: '入口速度恆等式; 手算自由流速度 U∞ vs 執行的面積加權平均入口速度 U_in,avg。1% 誤差容限。',
      yPlusBandsPending:
        '目標 y⁺ 帶(<5 / 5-30 / 30-100 / >100)內濕壁面積比覆蓋; 尚未支援。實作後此軸將計分壁面位於對數律有效範圍內的比例。',
      nutRatioPending:
        '湍流黏度比百分位(P10 / P50 / P90);尚未支援。實作後此軸將標記湍流模型幾乎無貢獻的執行(P50 低於 1 表示湍流範本下的層流式解)。',
      massBalancePending:
        '直接質量守恆比例; 此範本尚未支援為一等欄位(目前可由 |Q_in| ≈ |Q_out| 間接導出)。專用欄位發布前保留佔位。',
      deadVolumePending:
        '流體域中無明顯流動的比例; 尚未支援。捕捉大部分域停滯但執行仍報告成功的失敗模式。',
      blockagePending:
        '阻塞比(投影正面積 / 圍體斷面積);尚未支援。將標記外部流執行中過小圍體導致自由流受壁面束縛的情況。',
    },
  },
  surrogate: {
    loocvSummary:
      '第 {{iteration}} 次迭代、橫跨 {{runs}} 次已完成執行的 LOOCV：{{metrics}}',
  },
  chtViz: {
    regions: '區域',
    regionLocked: '至少會保留一個區域顯示。',
    uncoloured: '灰色：{{regions}}沒有{{field}}',
    uncolouredMore_one: '另外{{count}}個',
    uncolouredMore_other: '另外{{count}}個',
    noFiles: '此執行尚無可視化檔案。',
    noSurface: '此區域尚無表面檔案。',
  },
  viewer: {
    extremaToggle: '最大/最小',
    extremaMax: '最大:',
    extremaMin: '最小:',
    extremaMaxName: '最大值',
    extremaMinName: '最小值',
    extremaA11y: '{{quantity}}{{name}}：{{value}}',
    extremaMoveHint: '使用方向鍵移動此標籤。',
    extremaTied_one: '（另有{{n}}點同值）',
    extremaTied_other: '（另有{{n}}點同值）',
    extremaOnSlice: '切片上',
    extremaBehind: '在模型背面',
    extremaOffView: '在視野外',
    lockRange: '鎖定色階範圍',
    rangeLocked: '範圍已鎖定',
    rangeClamped: '峰值超出鎖定範圍',
    rangeMin: '範圍最小值',
    rangeMax: '範圍最大值',
    fitToVisible: '符合可見範圍',
    sliceLoading: '正在載入切片…',
    sliceFieldUnavailable: '切片不包含{{field}}。',
    field: '欄位',
    visibilityShown: '{{label}}：顯示 {{shown}} / {{total}} 個',
    colormap: '色彩對應',
    units: '單位',
    loadConditions: '載荷條件',
    boundaryConditions: '邊界條件',
    volumeSurface: '體積表面',
    volumeSurfaceTooltip:
      '流體域的簡化表面,依所選欄位著色。外流時包含物體壁面;外圍框線為獨立恆常繪製的邊界框. 取消勾選可在無表面遮擋下觀察流線 / 熱點.',
    bodyOpacity: '本體',
    streamlines: '流線',
    streamlineDensity: '條數',
    streamlineDensityName: '顯示條數',
    streamlineDensityCount: '{{drawn}} / {{total}} 條',
    streamlinesTooltip:
      '流體域內灑點追蹤的流線; 依 |U| 著色,與所選欄位無關. 顯示流場拓撲(附著 / 分離 / 迴流). 需求解器有輸出流線檔案時可用.',
    hotspots: '熱點',
    hotspotsTooltip:
      '壁面純量場的極值點(壓力峰值、冷熱點、高 y⁺、高 ν_t/ν). 以標記球呈現於表面;可用下方欄位按鈕過濾.',
    fields: '物理量',
    pick: {
      heading: '點選',
      close: '關閉點選讀值',
      position: '位置',
      patch: '面片',
      cellId: '單元 #',
    },
    customColors: {
      custom: '自訂',
      edit: '編輯顏色',
      title: '配色',
      description:
        '選擇配色，或選擇自訂來變更低值、中間值和高值的顏色。關閉此視窗後，模型才會更新。',
      saveFailed: '顏色尚未儲存，請重試。',
      preview: '顏色預覽',
      low: '低值',
      middle: '中間值',
      high: '高值',
      loading: '正在載入已儲存的顏色…',
      loadFailed: '無法載入已儲存的顏色。',
      saving: '正在儲存顏色…',
      saved: '顏色已儲存',
      temporary: '顏色僅套用於此頁面。',
      idle: '',
    },
    colormapPresets: {
      'Cool to Warm': '冷至暖',
      'Viridis (matplotlib)': 'Viridis (matplotlib)',
      'Plasma (matplotlib)': 'Plasma (matplotlib)',
      'Inferno (matplotlib)': 'Inferno (matplotlib)',
      'Black-Body Radiation': '黑體輻射',
      'X Ray': 'X 光',
    },
    aboutField: '關於 {{field}}',
    aboutTemperature: '關於溫度',
    loadingVisualization: '正在載入視覺化…',
    loadStage: {
      listing: '正在尋找結果檔案…',
      fetching: '正在下載結果…',
      parsing: '正在讀取結果…',
      building: '正在建立 3D 視圖…',
    },
    loadBytes: '{{loaded}} / {{total}}',
    loadBytesSoFar: '已下載 {{loaded}}',
    volumeUnavailable: '體積表面無法使用：{{message}}',
    streamlinesUnavailable: '流線無法使用：{{message}}',
    streamlinesTooShort:
      '求解器的流線在此比例下太短而無法顯示，因此看不到任何內容。問題出在這次執行而非此檢視。',
    streamlinesEmpty: '這次執行沒有產生流線，因此這裡沒有可繪製的內容。',
    streamlinesStillborn:
      '求解器的流線幾乎立即離開計算域，因此繪製後看不到任何內容。問題出在這次執行而非此檢視。',
    hotspotsUnavailable: '熱點無法使用：{{message}}',
    slice: '切片',
    sliceTooltip:
      '以軸對齊平面切開流體域. 顏色範圍會依當前切片重算, 不會因單一極端值而整片被沖淡.',
    sliceAxis: '軸向',
    slicePosition: '位置',
    sliceUnavailable: '切片無法使用：{{message}}',
    clip: '剖面 (Section)',
    clipTooltip:
      '以共用平面切開每個邊界貼片與體積表面, 讓使用者看進幾何內部. 與體積切片互補; 這裡切的是表面本身, 未帶重取樣場的研究也能得到剖面視圖.',
    clipAxis: '軸向',
    clipPosition: '位置',
    clipFlip: '翻面 (Flip)',
    clipFlipTooltip: '保留切面另一側.',
    probeLine: '探測線',
    probeLineTooltip:
      '在直線所穿過的幾何上, 繪出探測圖正在取樣的那條線. 若直線正好擋住想觀察的部位, 可將其隱藏.',
    boundaryPatch_one: '{{count}} 個邊界貼片',
    boundaryPatch_other: '{{count}} 個邊界貼片',
    showLess: '收合',
    showMore: '+{{count}} 更多',
    hotspotsCount: '熱點（{{count}}）',
    hotspotsShowAll: '顯示全部 {{count}} 項',
    hotspotsShowLess: '收合',
    failedVisualization: '無法載入視覺化',
    failure: {
      notReadyTitle: '結果尚未就緒',
      notReadyBody:
        '這次執行尚未寫出結果。若仍在進行中，完成後就會在此顯示 3D 檢視。',
      notReadyNotice: '這次執行尚未寫出',
      linkExpiredTitle: '此頁面開啟太久了',
      linkExpiredBody: '結果檔案的連結有效一小時。請重新整理頁面以取得新連結。',
      linkExpiredNotice: '連結已失效，請重新整理頁面',
      artifactMissingTitle: '找不到結果檔案',
      artifactMissingBody:
        '這次執行列出的檔案已不存在。請重新整理頁面；如果問題持續發生，請告訴我們。',
      artifactMissingNotice: '檔案已不存在；如果問題持續發生，請告訴我們',
      forbiddenTitle: '您沒有檢視這些結果的權限',
      forbiddenBody:
        '請向這個研究的擁有者申請權限。其餘可見內容是您目前權限的範圍。',
      forbiddenNotice: '您目前的權限無法檢視',
      noResultsTitle: '沒有可顯示的結果',
      noResultsBody:
        '沒有可供 3D 檢視顯示的內容。這次執行的數值與圖表不受影響。',
      noResultsNotice: '這次執行沒有產生',
      fetchFailedTitle: '無法載入結果',
      fetchFailedBody:
        '無法下載結果檔案。請重新整理頁面；如果問題持續發生，請告訴我們。',
      fetchFailedNotice: '無法下載，請重新整理頁面',
      unreadablePayloadTitle: '結果格式不符預期',
      unreadablePayloadBody:
        '這次執行的視覺化資料不是本檢視器能讀取的格式。請告訴我們。',
      unreadablePayloadNotice: '不是本檢視器能讀取的格式',
      loadStalledTitle: '載入已停滯',
      loadStalledBody:
        '一段時間內沒有收到任何資料。請重試；若再次停滯，此結果可能過大，瀏覽器無法繪製——其數值與圖表不受影響。',
      loadStalledNotice: '載入停滯——請重試',
    },
  },
  viewerControls: {
    showControls: '顯示檢視器控制項',
    mouse: '滑鼠',
    dragL: '左鍵拖曳',
    tumble: '翻轉（偏航 + 俯仰）',
    dragR: '右鍵拖曳',
    pan: '平移',
    dragLR: '左 + 右鍵拖曳',
    roll: '滾轉',
    wheel: '滾輪',
    zoom: '朝游標縮放',
    rightClick: '右鍵',
    contextMenuSuppressed: '已停用內容選單',
    ctrlL: '左鍵點擊(靜止)',
    pick: '點選; 讀出游標處的表面資訊',
    keyboard: '鍵盤',
    lookAxis: '沿 X / Y / Z 軸檢視',
    pitch: '±90° 俯仰',
    yaw: '±90° 偏航',
    rollKey: '±90° 滾轉',
    slice: '沿目前檢視做剖面裁剪（尚未接線）',
    toggleSlice: '切換體積切片',
    resetView: '將視角重設為預設檢視',
  },
  guard: {
    // 守衛列以後端回報的代碼作為標題時的標籤。數量在明細欄，
    // 原因敘述由守衛面板負責，因此這裡只用簡短名詞片語。
    simErrorCode: {
      divergencePressure: '壓力發散',
      divergenceVelocity: '速度發散',
      divergenceTurbulence: '紊流量發散',
      courantNumberExceeded: 'Courant 數超過上限',
      nanInField: '場中出現 NaN',
      sigfpeInField: '場中出現浮點例外',
      massImbalanceHigh: '質量不平衡過大',
      continuityErrorHigh: '連續性誤差過大',
      wallYplusOutOfRange: '壁面 y⁺ 超出範圍',
      solidTRanAway: '固體溫度發散',
      interfaceUncoupled: '界面未耦合',
      heatSourceNoTarget: '熱源沒有作用對象',
      inletOutletReversed: '進出口反向',
      solutionHeavilyClamped: '解被大量鉗制',
      transverseForceAsymmetry: '橫向力不對稱',
    },
    title: '結果檢核',
    subtitle: '已完成但可能不可信的計算',
    flaggedCount: '{{total}} 筆中有 {{flagged}} 筆被標記',
    allClear: '無異常訊號; 所有已完成的計算在物理上皆合理。',
    noRuns: '沒有可檢查的已完成計算。',
    unphysical: '非物理',
    remediation: '處理方式：',
    codeLabel: '代碼：',
    reasons: {
      wallYPlusMaxAbove:
        '壁面 y+ 最大值為 {{value}}，超過對數律有效範圍 ({{threshold}})；壁面剪應力數值不可靠。',
      wallYPlusMinBelow:
        '壁面 y+ 最小值為 {{value}}，低於對數律有效範圍 ({{threshold}})；壁面函數在此不適用。',
      wallYPlusBufferBand:
        '{{value}}% 的壁面面積落在 y+ 5–30 緩衝層 (上限 {{limit}}%)，此處黏性底層解析與壁面函數兩種處理皆不成立；壁面剪應力數值不可靠。',
      wallYPlusSublayerLogLaw:
        '{{value}}% 的壁面面積低於 y+ 5 (上限 {{limit}}%)，但壁面處理假設對數律；壁面函數在此不適用。',
      wallYPlusMeanBelowNoFractions:
        '壁面 y+ 平均值為 {{value}}，低於對數律有效範圍 ({{threshold}})，但壁面處理假設對數律，且此次計算沒有壁面面積比例；壁面函數在此不適用。',
      massImbalance:
        '入口與出口的質量守恆偏差為 {{value}}%；計算域未能守恆質量。',
      fluidLimitersClamped:
        '流體限制器在最終迭代鉗制了 {{value}}% 的網格 (超過 {{threshold}}% 的門檻)。此執行雖已收斂,但求解器一直在壓制場 — 在鉗制區域重新產生網格或改變驅動條件之前,請將溫度視為指示性數值。',
    },
    remediations: {
      wallYPlusRange:
        '壁面 y+ 超出壁面函數有效範圍。調整初始高度使 y+ 落在 30–100 之間。',
      wallYPlusModelAware:
        '壁面 y+ 超出此次計算壁面處理可支援的範圍。請調整初始高度：y+ ≈ 1 可解析黏性底層 (k-ω SST)；30–100 僅適用於壁面函數 (k-ε)；並避開 y+ 5–30 緩衝層。',
      wallYPlusResolving:
        '此紊流模型在 y+ ≈ 1 時可解析黏性底層；30–100 僅適用於壁面函數。請將初始高度移出 y+ 5–30 緩衝層：要 y+ ≈ 1 就調小，要 30–100 就調大。',
      wallYPlusLogLaw:
        '使用對數律壁面函數的 k-ε 需要第一層網格位於對數律區域。請提高初始高度使 y+ 落在 30–100 之間，或改用 k-ω SST (或同時使用低雷諾數 epsilon 與 nut 壁面函數) 以 y+ ≈ 1 解析黏性底層。',
      massImbalance:
        '入口與出口之間的質量通量差距過大。檢查邊界條件是否遺漏出口,或提高非正交修正次數。',
      solutionHeavilyClamped:
        '流體限制器鉗制了大量網格,因此此解只能作為指示性參考，而非錯誤 — 執行雖已收斂,但求解器一直在壓制場。預期能量平衡讀值會偏高: 速度限制器逐格改寫速度場 U，卻未改寫質量通量,焓對流項對照不再匹配的通量計算。請於鉗制發生區域粗化或修復網格,或調降入口流速,並在信任溫度前重新執行。',
    },
    humanizedCode: {
      massImbalance: '質量守恆偏差 {{value}}%',
    },
  },
  cht: {
    interfaceHeatFlux: '傳入冷媒的熱量',
    peakFlux: '峰值通量',
    converged: '計算已收斂',
    runtime: '執行時間',
    energyBalance: '能量守恆',
    energyBalanceOk: '在捨入誤差內閉合',
    fluxResolutionOk: '面積分值一致',
    fluxResolutionCoarse: '面積分值不一致 — BC 面網格過粗',
    fluxResolutionCoarseFace: '面積分值不一致 — {{face}} 網格過粗',
    coarseFaceMark: '· 過粗',
    faceHeating: '加熱',
    faceCooling: '冷卻',
    faceHeatRateLegendShort: '紅=加熱 · 藍=冷卻',
    faceHeatRateLegend: '正瓦特加熱固體（紅）；負瓦特冷卻固體（藍）。',
    imbalanceInflowTooltip:
      '淨流入 — 進入固體的熱（{{in}}）多於離開的熱（{{out}}）。不平衡為 |入 − 出|。',
    imbalanceOutflowTooltip:
      '淨流出 — 離開固體的熱（{{out}}）多於進入的熱（{{in}}）。不平衡為 |入 − 出|。',
    imbalanceBalancedTooltip:
      '進熱與出熱在捨入誤差內相符。不平衡為 |入 − 出|。',
    imbalanceCoarseFace: '可能過粗的 BC 面：{{face}}。',
    energyImbalanceTooltip:
      '未閉合的能量：|E_in − E_out − ΔU_stored|。剩餘為正表示該時段能量簿記未守恆。',
    energyBalanceWarn: '軟閉合 — 請看說明',
    energyBalanceFail: '未閉合 — 求解器沒有守恆能量',
    energyBalanceTooltip:
      '投入的熱是否等量流出? 比對宣告熱源與求解器界面熱通量，將不平衡以 % 回報。號誌判定: 綠 = 相符、黃 = 有說明的軟閉合 (未收斂、速度限幅器動作)、紅 = 未閉合 — 讀者不應信任溫度結果。',
    iterations: '{{count}} 次迭代',
    belowLimit: '✓ 低於 {{temp}} °C 上限',
    aboveLimit: '⚠ 高於 {{temp}} °C 上限',
    regions: '區域',
    heatSource: '熱源',
    tMin: '最低溫',
    tAvg: '平均溫',
    tMax: '最高溫',
    uMax: '最高流速',
    chipTmaxTooltip:
      '任何具熱源固體區域中的最高溫度。用以對照目標溫度來決定通過/失敗標記。',
    pressureDropTooltip: '流體區域從入口到出口的壓力損失。',
    pressureDropReversed: '壓力上升; 入口與出口可能顛倒',
    interfaceHeatFluxTooltip:
      '本次執行中固體經由所有流體 ↔ 固體介面傳給冷媒的淨瓦數。本次介面: {{patches}}。正值為正常冷卻方向; 負值表示冷媒正在加熱固體。逐介面拆分會顯示在區域圖上。',
    interfaceHeatFluxIntro:
      '本次執行中固體經由所有流體 ↔ 固體介面傳給冷媒的淨瓦數 (負值: 冷媒正在加熱固體)。',
    interfacePatchesLabel: '介面:',
    interfaceLegend:
      '箭頭指向熱流動的方向: 紅 = 釋放熱的區域, 藍 = 接收熱的區域。固體 → 冷媒為正常冷卻方向; 反向通常代表入口/出口顛倒或熱源宣告錯誤。',
    interfaceHeatFluxTooltipTrans:
      '本次執行中固體經由所有流體 ↔ 固體介面傳給冷媒的淨瓦數。介面: {{patches}}。<heat>紅</heat> = 釋放熱的區域, <cool>藍</cool> = 接收熱的區域; 固體 → 冷媒為正常冷卻方向。',
    peakFluxTooltip:
      '流體 ↔ 固體介面上任一處的最大局部熱通量。本次峰值位於: {{patch}}。數值高表示可能需要更多網格細化的熱點。',
    peakFluxIntro: '流體 ↔ 固體介面上的最大局部熱通量。',
    peakPatchLabel: '峰值位於:',
    peakFluxOutro: '數值高代表可能需要更細的網格。',
    peakFluxTooltipTrans:
      '流體 ↔ 固體介面上的最大局部熱通量。峰值位於 <heat>{{patch}}</heat>。數值高代表可能需要更細的網格。',
    patchListUnavailable: '本次執行未回傳',
    convergedTooltip:
      '求解器的殘差是否在耗盡迭代次數前降至設定的容差以下。✓ 表示結果穩定；;表示用盡整個迭代預算仍未收斂。',
    runtimeTooltip: '求解器在此設計點上花費的實際秒數（不含網格化時間）。',
  },
  chtAnchors: {
    subtitle:
      '輸入你預期此次執行對應的參考值。求解器結果 + 材料庫可初始化的欄位會自動填入，D_h 與 L 若已在此次執行中宣告也會填入；仍為空白的欄位請手動輸入。Reset 會將所有欄位還原為初始值。',
    assumptionsHeading: '假設',
    derivedHeading: '導出',
    resetLabel: '將假設欄位還原為初始值',
    resetTooltip: '重設',
    refPickerLabel: '{{row}} 的參考值',
    missingInputHint: '等待 {{variable}}',
    refPickerTitle: '參考值',
    refPickerHint:
      '參考公式 — 唯讀。挑選符合散熱片的幾何形狀,手動套用方程式,再將結果填入上方列。',
    refs: {
      genericCoolant: '此冷卻液',
      Nu: {
        laminarWallT: '層流管道，壁溫定',
        laminarWallQ: '層流管道，壁熱通量定',
        gnielinski: '湍流 (Gnielinski)',
        dittusBoelter: '湍流 (Dittus-Boelter)',
        description: {
          laminarWallT:
            '圓管在充分發展層流、壁溫固定下的常數。這不是相關式，而是由解出的速度與溫度分佈直接得到，因此沒有擬合、也沒有散佈帶。請當作下限使用 — 層流通道不會比這更差。',
          laminarWallQ:
            '同一組解，但壁面邊界條件改為均勻熱通量。相對於 (T_wall − T_bulk)，定熱通量的分佈維持較陡的壁面梯度，因此數值較高；壁溫固定時，流體逐漸接近壁溫，該梯度會鬆弛。要用哪一個取決於邊界條件，而非流動本身。',
          gnielinski:
            '通用的紊流相關式；在適用範圍內應優先採用。它涵蓋過渡區、Prandtl 數範圍寬，且明確帶入摩擦係數而非假設光滑管。分子含 (Re − 1000)，因此 Re ≈ 1000 以下會回傳負值 — 那是超出適用範圍的訊號，不是計算結果。',
          dittusBoelter:
            '較舊的簡化紊流擬合式。便於手算且仍被廣泛引用，但對實測資料僅約 ±25 % 的準確度：它忽略壁面與主流的物性變化，因此溫差越大偏離越多。對{{fluid}}尤其明顯 — 其黏度隨溫度變化，而這正是 Sieder-Tate 的 (μ/μ_s) 項所要修正、本相關式卻省略的部分。若落在 Gnielinski 的適用範圍內請優先採用，並將 Gnielinski 與 Dittus-Boelter 的一致視為佐證，而非把任一個當成真值。',
        },
        validity: {
          laminar: '完全發展層流 — Re < 2300',
          gnielinski: '3 × 10³ < Re < 5 × 10⁶,0.5 < Pr < 2000',
          dittusBoelter:
            'Re > 10⁴,0.7 < Pr < 160,且入口段長度至少為管徑的 10 倍',
        },
      },
      eps: {
        rectStraight: '矩形鰭片',
        triangularStraight: '三角形鰭片',
        annular: '環形鰭片',
        pinFin: '針形鰭片 (圓柱)',
        arrayOverall: '鰭片陣列整體效率 η_o',
        ntuPredicted: '由流道流動預測',
        validity: {
          ntuPredicted:
            '單一流體、壁溫固定,並符合 Gnielinski 適用範圍 (3 × 10³ < Re < 5 × 10⁶,0.5 < Pr < 2000). 完全不使用本次運算的發熱量與溫度,因此與上方數值的差距是可用的證據,而非同一算式的重述.',
        },
      },
    },
    units: {
      massFlow: 'kg/s',
      specificHeat: 'J/(kg·K)',
      dimensionless: '無因次',
    },
    backsolve: {
      heading: '反解',
      subtitle:
        '輸入預期的參考值；面板會反解定義方程，返回可預先登記的預測結果，或需要調整的幾何/設定輸入。主輸入下方出現第二個輸入的列，代表該列需要一個此次執行未回報的額外數值 (D_h、A_in、A_wet) — 請於該列中直接輸入。',
      headers: {
        row: '列',
        typeIn: '輸入',
        typeInHint:
          '主輸入為該列的預期參考值。旁邊較小的輸入欄是執行未攜帶的幾何值 — D_h (水力直徑)、A_in (入口截面積)、A_wet (界面濕潤面積)。請為要反解的列填入所需值。',
        backsolve: '反解結果',
      },
      rows: {
        R: {
          label: 'R 預期 → 預測 T_source',
          hint: '輸入預期熱阻，回傳執行應到達的溫度。T_source = T_in + Q̇·R_exp 事前登記，再與執行的熱點溫度比較。',
          output: 'T_source',
        },
        rthQMax: {
          label: '目標 T + R_th → 封裝功率預算 Q̇_max',
          hint: 'R 預期列的互補反解。輸入部件不可超過的溫度與（右側 R_exp 輔助輸入）預期熱阻，回傳 Q̇_max = (T_target − T_in) / R_exp — 執行管路能承載且接點不會超過極限的最大熱負載。可用於封裝選型的功率預算，或熱源非電子零件（加熱元件、馬達線圈、LED）時的降額檢查。需同時輸入 T_target 與 R_exp，且 T_target > T_in 才會計算。',
          qMax: 'Q̇_max',
        },
        dtBudget: {
          label: 'ΔT 預算 → 需求 ṁ + U_inlet',
          hint: '給定允許的冷媒焓升 ΔT 與宣告的 Q̇，所需冷媒質流為 ṁ = Q̇/(c_p·ΔT)。除以 ρ·A_inlet 得到寫入設定的入口速度。',
          mDot: 'ṁ',
          uInlet: 'U_inlet',
        },
        epsExpected: {
          ntuTip:
            'NTU (Number of Transfer Units, 傳熱單位數) = U·A / C_min — 熱交換器的無因次傳熱尺寸。粗略地說,冷媒可被平均 ΔT 加熱多少次。單流 / 壁溫恆定下 NTU 1 / 2 / 3 → ε 0.63 / 0.86 / 0.95。',
          label: 'ε 預期 → 需求 NTU + U·A_wet',
          hint: '熱交換器 ε (Kays & London),非鰭片效率。ε 為輸入值: 在此指定目標有效度 (回收理想 ΔT 的比例);右側 NTU 與 U·A_wet 為本列計算輸出。越接近 1.0,面積成本增加越快。NTU (Number of Transfer Units) = U·A / C_min 是熱交換器的無因次傳熱尺寸。單流 / 壁溫恆定: NTU = −ln(1−ε),U·A_wet = NTU · ṁ · c_p。NTU 1 / 2 / 3 → ε 0.63 / 0.86 / 0.95。對向流、平行流、交叉流與混合配置各有自身的 ε-NTU 曲線,請讀 Kays & London。鰭片面請改用 Incropera 第 3 章的鰭片效率 η_fin。',
          // A symbol, so the same in every locale — but a key rather than a
          // literal, because every other output label on these rows is one and
          // the renderer translates them all the same way.
          ntu: 'NTU',
          uaWet: 'U·A_wet',
          arrangement: '配置',
          arrangementValue: '單流 / 壁溫恆定',
        },
        piBudget: {
          label: 'Π 預算 → 最大 Δp',
          hint: 'Π = Δp / (ρ · c_p · ΔT)。以「比值」輸入泵送成本預算 (通常 < 1 %) — 輸入 0.01 或 1% 皆可，兩者存入相同數值。面板回傳此冷卻工作可用的最大壓損 — 泵浦端的上限。',
          dP: '最大 Δp',
        },
        reTarget: {
          label: 'Re 目標 → 需求 U_inlet',
          hint: '給定相關式列有效的雷諾數與流道水力直徑，所需入口速度為 U = Re · ν / D_h。',
          uInlet: 'U_inlet',
        },
        nuExpected: {
          label: 'Nu 預期 → 預測壁面 ΔT',
          hint: '輸入此流道的公開 Nu 值，回傳壁面比冷卻劑高出多少度。ΔT_wall = T_wall − T_coolant — 就是 ΔT (部分教科書亦稱壁面過熱)。公式: h = Nu · k_fluid / D_h; ΔT_wall = q″ / h (q″ ≈ Q̇_in / A_wet)。可預先登記壁面 ΔT 對照執行的峰值熱通量。',
          h: 'h',
          dtWall: 'ΔT_wall',
        },
        targetT: {
          label: '目標 T_max + Q̇ → 需求 Nu (可行性)',
          hint: '給定目標熱點溫度與宣告熱功率，需要的 h = Q̇ / (A_wet · (T_target − T_bulk))；需要的 Nu = h · D_h / k_fluid。當 Nu_req 超過可達 Re 下相關式所給的 Nu 時，該設計無法達成，任何網格都無法修正。',
          hReq: 'h_req',
          nuReq: 'Nu_req',
        },
        biLimit: {
          label: 'Bi 最大值 → 最大集總電容固體 L_max',
          hint: '固體到多厚就不能再視為一個均一溫度? 輸入你能接受的集總電容 Biot 最大值 — 教科書標準為 0.1 (Incropera 第 5 章)。Bi_max 是「仍可視為集總電容的最大 Biot 值」上限 (小 Bi = 內部均溫)。回傳仍能維持集總電容近似的最大厚度 L_max。厚過此值,內部會出現不可忽略的 ΔT,表面溫度就無法代表內部最熱點。公式: L_max = Bi_max·k_solid / h; 若厚度固定,可反推 k_req = h·L / Bi_max 挑高導熱材料。h 來自上方 Nu 預期列或目標-T 可行性列 — 輸出列會顯示採用來源。若 h 顯示「不可用」,請先填其中一列。',
          lMax: 'L_max',
          h: 'h',
          hSource: 'h 來源',
          hSourceNu: 'Nu 預期列',
          hSourceTargetT: '目標-T 可行性列',
          hSourceNone: '不可用 — 請先填 Nu 預期或目標-T',
          hSourceNuShort: 'Nu 來源',
          hSourceTargetTShort: '目標-T 來源',
        },
        rePlusPr: {
          label: 'Re + Pr → 最小發展長度',
          hint: '層流 (Re < 2300): L_t ≈ 0.05·Re·Pr·D_h；L_h ≈ 0.05·Re·D_h。湍流: L_t ≈ L_h ≈ 10·D_h。更短的通道對應發展中流動而非完全發展流。',
          lT: 'L_t (熱)',
          lH: 'L_h (流體力學)',
        },
        interfaceScale: {
          label: '界面熱通量配對 → A_wet 尺度檢查',
          hint: 'A_wet ≥ Q̇_iface / q″_peak。自動 — 無需輸入。當此下界與 CAD 相差約 100 倍以上時，很可能是單位/尺度錯誤 (CFD 長度尺度檢查的 CHT 版)。',
          aWetMin: '最小濕潤面積',
        },
      },
    },
    radar: {
      heading: '自洽性雷達圖',
      subtitle:
        '分數僅取最差軸。一次執行即使通過此處所有算術恆等式，仍可能非物理，請視為自我測試。',
      empty: '尚未有可評分的已完成 CHT 設計點。',
      noScoreable:
        '此執行沒有宣告的熱源，也沒有冷媒側資料 — 每個軸皆被阻塞，雷達無法繪製任何內容。請宣告總功率熱源，或等待輸出冷媒欄位的執行。',
      identityBand: '恆等式 · 1% 帶',
      correlationBand: '相關 · 30% 帶',
      pending: '等待執行界面資料',
      distributionHeading: '評分軸分佈',
      worst: '最差',
      median: '中位',
      best: '最佳',
      symbol: '符號',
      hand: '手算',
      solver: '求解器',
      deltaPct: 'Δ %',
      score: '分數',
      placeholderTooltip: '此軸為佔位符 — 求解器尚未輸出兩側資料。',
      kinds: {
        identity: '恆等式',
        correlation: '相關',
        placeholder: '佔位符',
      },
      axes: {
        qInterface: '界面熱流量',
        qCoolant: '冷媒熱流量',
        qCoolantInterface: '冷媒↔界面',
        qV: '體積發熱密度',
        epsilon: '效率',
        R: '熱阻',
        Bi: '固體均溫',
        Nu: '努塞爾數',
        j: 'Colburn j 因子',
      },
      tooltips: {
        qInterface:
          '宣告熱功率與求解器回報的流體–固體界面熱通量比較。恆等式 — 收斂執行應在捨入誤差內閉合。',
        qCoolant:
          '宣告熱功率與冷媒焓升 (ṁ · c_p · ΔT) 比較。恆等式 — 需要較新版求解器的冷媒側統計。',
        qCoolantInterface:
          '兩個 SOLVER 側能量總量互相比對: 流體–固體界面熱通量 vs 冷媒帶出的焓升 (ṁ · c_p · ΔT)。與宣告值獨立 — 兩者不一致代表 SOLVE 沒有守恆 (部分平衡、被漏掉的壁面、未計入界面總和)。恆等式 — 應在捨入誤差內閉合。',
        qV: '體積發熱密度 q̇_v = Q̇/V_source，宣告側 vs 測定側 (Q̇_interface/V_source)。恆等式 — 閉合代表每一瓦投入熱源固體都從流體界面流出。差異代表界面總和未計入的熱路徑 (固體外環境 BC、另一組固體–固體界面)。若舊執行未回報熱源固體的網格化體積則暫不評分。',
        epsilon:
          'ε = Q̇ / (ṁ · c_p · ΔT_max)。相關帶分數，以典型 ε-NTU 甜蜜點 ~0.7 為目標。',
        R: 'R = (T_source − T_in) / Q̇。相關帶分數，以典型液冷冷板目標 ~1 K/W 為目標。',
        Bi: 'Bi = h · L / k_solid。評分需要執行尚未輸出的 h 估算 (濡潤界面積 + 壁面–主流 ΔT)。',
        Nu: 'Nu = h · D_h / k_fluid。評分需要執行尚未輸出的 h 估算 (濡潤界面積 + 壁面–主流 ΔT)。',
        j: 'j = St · Pr^(2/3)。評分等待與 Nu / Bi 相同的 h 估算。',
      },
    },
    chtChecks: {
      heading: '一致性檢核',
      subtitle:
        '乾淨執行下必須在捨入誤差內成立的恆等式。此處的 Δ 是管線錯誤 (標籤互換、將 null 讀為零、能量平衡不完整)，並非驗證信號。',
      headers: {
        identity: '恆等式',
        hand: '手算',
        solver: '求解器',
        absDelta: '|Δ|',
        pctDelta: 'Δ %',
      },
      rows: {
        qInterface: {
          label: '輸入功率 ↔ 通過流體–固體界面的功率',
          hint: '將此執行固體區域宣告的總功率熱源總和，與求解器計算的界面熱通量比對。收斂執行應在捨入誤差內閉合；大幅 Δ 表示求解器並未將宣告的全部瓦數送過流體–固體界面。',
        },
        qCoolant: {
          label: '焓守恆 · 投入熱量 ↔ ṁ·c_p·ΔT',
          hint: '焓守恆檢查: 冷媒焓升 (ṁ · c_p · ΔT) 應與固體區域宣告的熱源總量相等。若差異很大，表示冷媒帶走的熱量多於或少於熱源投入的熱量 — 可能是外部 BC 洩漏、符號錯誤、或入口/出口顛倒。需要較新版求解器執行的冷媒側統計欄位。',
        },
        qBothSides: {
          label: '|Q̇_fluid| ↔ |Q̇_solid| (界面閉合)',
          hint: '純粹求解器側檢查 — 流體側界面收到的瓦數應與固體側放出的瓦數大小相同、符號相反。以絕對值比較，讀者不需追蹤符號規約。與宣告值獨立 — 差異代表界面耦合本身未閉合 (求解器未加總的成對 patch、網格非正交造成的熱通量不均)。',
        },
        qCoolantInterface: {
          label: '能量守恆 · Q̇_interface ↔ ṁ·c_p·ΔT',
          hint: '兩個 SOLVER 側能量總量互相比對: 流體–固體界面熱通量 vs 冷媒帶出的焓升。與宣告值獨立 — 兩者不一致代表 SOLVE 沒有守恆 (部分平衡、被漏掉的壁面)。qInterface 與 qCoolant 各自可能與宣告值閉合，但這兩者不一致的情況由本列捕捉。',
        },
        qV: {
          label: '體積發熱密度 · Q̇/V_source ↔ Q̇_iface/V_source',
          hint: '宣告側的體積發熱密度 (Q̇/V_source) vs 測定側 (Q̇_interface/V_source)。閉合代表投入熱源固體的每一瓦都從流體界面流出。差異代表界面總和未計入的熱路徑 (固體外環境 BC、另一組固體–固體界面)。需要熱源固體的網格化體積。',
        },
        massImbalance: {
          label: 'ṁ 入口 ↔ ṁ 出口 (質量平衡)',
          hint: '求解器回報的冷媒質量不平衡應為 ~0。非零表示求解器未能於捨入誤差內閉合質量平衡。',
        },
      },
      pending: {
        qDeclared: '沒有可比對的提交熱源 — 請宣告或手動輸入功率。',
        interface: '開發中。',
        coolant: '開發中。',
      },
    },
    tooltips: {
      dh: '流道水力直徑。若此次執行已宣告此值則自動填入；否則請輸入幾何值或合理估算 (4·A/P)。兩種情況都屬宣告值，並非求解結果。',
      L: '固體熱傳路徑特徵長度 (通常為熱穿過的固體厚度)。若此次執行已宣告此值則自動填入；否則請手動輸入。並非求解結果。',
      qDot: '此執行固體區域宣告的總功率熱源總和。以 W/m³ 密度宣告的執行需要此次執行未回報的區域體積 — 該情況請手動輸入。',
      tSource:
        '最高固體溫度 — 若執行有命名熱源固體則採其最高溫度，否則採所有固體區域的最高值。',
      tIn: '流體入口溫度 — 執行提交時的邊界條件。',
      dP: '流體區壓力損失。',
      mDot: '冷媒質量流量 — 新的執行自動填入，較舊的執行為空。空欄可手動輸入。',
      dT: '冷媒焓升 — 與質量流量的配線狀況相同。',
      kSolid:
        '從材料庫取得的固體導熱係數 (依第一個固體區域的材料)。多固體場景亦僅顯示單一值; 每區 k_solid 為後續工作。',
      kFluid: '直接取用 FLUID_MATERIAL 庫項的值。',
      rho: '執行的冷媒庫項目中的流體密度。',
      cp: '執行的冷媒庫項目中的流體比熱。',
      prandtl:
        '流體 Prandtl 數，由庫項以 Pr = ρ·ν·c_p/k 推算，即傳給求解器的值。',
      vSolid:
        '熱源固體的網格化體積 — 承載宣告發熱源的區域體積。用於 q̇_v = Q̇ / V_solid；可對照封裝規格檢查接點功率密度。',
      aWet: '流體 ↔ 固體所有 patch 對的濡潤界面積總和。用於 h_eff = Q̇ / (A_wet · ΔT)。舊執行為空 — h_eff 會退回 L² 近似。可覆寫以在不重跑的情況下測試設計變更。',
    },
    state: {
      needsCoolant: '等待求解器的冷媒集合值 (ṁ + ΔT)。',
      needsDh: '需要輸入水力直徑 D_h。',
      needsBoth: '等待求解器的冷媒集合值與水力直徑 D_h。',
      missingInputs: '缺少輸入：{{missing}}',
    },
    rows: {
      R: {
        label: '熱阻 R',
        reference:
          '零件每必須散出一瓦會升高多少度。越低越好。液冷冷板通常落在 0.1〜10 K/W——偏離時可拆成導熱／壁面到冷媒／冷媒升溫，找出落差落在哪一段。',
        source: '熱歐姆定律・單相液冷冷板設計準則',
      },
      Bi: {
        label: '固體均溫性 (Bi)',
        observed: 'Δ{{region}} = {{dt}} K',
        reference:
          '檢查固體零件是否可近似為單一溫度。金屬通常可以；內部溫差大時指向零件接觸或設定中的材料值。Bi < 0.1 = 集中容量；僅為方向性檢查，故實測溫差高於 Bi 預測時，應懷疑介面耦合或導熱係數輸入。',
        source: '集中容量法・Incropera 第 5 章',
      },
      Nu: {
        label: '努塞爾數 Nu',
        reference:
          '衡量流動冷媒帶走熱量相對靜止流體好多少。依通道類型對照發表值：Shah & London 層流精確值 3.66 / 4.36（壁面條件可移動 19 %）、Gnielinski ±10 %（3 × 10³ < Re < 5 × 10⁶）、Dittus-Boelter ±25 % 備援。',
        source: 'Gnielinski；Dittus-Boelter；Shah & London・Incropera 第 8 章',
      },
      Pi: {
        label: '泵送成本 Π',
        reference:
          '每移除一瓦熱量所花的泵送功率瓦數。健全液冷迴路遠低於 1 %。Π 上升會先顯示流道水力問題，早於溫度明顯變化。',
        source: 'Π = V̇·Δp / (ṁ·c_p·ΔT) = Δp / (ρ·c_p·ΔT)・液冷迴路設計準則',
      },
      j: {
        label: 'Colburn 因子 j',
        reference:
          '用執行自身交叉檢查：熱答案與壓降答案應來自同一壁面物理而一致。壁面剪力主導 Δp 時 j ≈ f / 8，±20 %；針鰭破壞 f 捷徑，量測的 j(Re) 仍有效。',
        source: 'Chilton-Colburn 類比・Incropera §6.8',
      },
      eps: {
        label: '效率 ε_HX',
        reference:
          '熱交換器有效度 — 此冷卻器與相同配置下最大可達熱交換的接近程度。1.0 為物理極限。ε = Q̇_in / (C_min · ΔT_max)，C_min = ṁ·c_p。依配置對照 ε-NTU 曲線 (Kays & London, ±10 %)；單流 / 壁溫恆定: ε = 1 − e^(−NTU)。與鰭片效率 ε_fin = q_fin / (h·A_b·(T_b − T_∞)) 或鰭片效率 η_fin 為不同量 — 鰭片面請參 Incropera 第 3 章 (矩形 / 三角形 / 環形 / 針形鰭片) 表格。',
        source: 'Kays & London・Compact Heat Exchangers',
      },
      qV: {
        label: '體積發熱密度 q̇_v',
        reference:
          '熱源固體單位體積的散熱功率 — 封裝規格中的接點密度指標 (加熱元件、線圈、LED 同理)。Q̇ / V_solid，V_solid 為承載熱源之區域網格化體積。典型 CPU 晶粒在 10⁸ W/m³ (100 MW/m³) 附近；顯著超過代表熱源固體的面積無法對應該功率密度，無論冷媒條件如何都會出現高溫。',
        source: '接點密度指標・對照封裝規格',
      },
      Rcond: {
        label: '導熱阻抗 R_cond',
        reference:
          '固體路徑的傅立葉阻抗 L / (k_solid · A)。這是沒有流體接觸的表面唯一適用的關係式——固體與固體的接觸沒有對流係數，因此 Nu、Colburn j 與第一層網格高度在該處都無定義。請與同一範圍下執行結果自身的 R = ΔT / Q̇ 以相同的 K/W 比較：一致代表接觸行為等同於所假設厚度的塊體導熱；手算值明顯低於求解值則代表真實接觸多出理想路徑沒有的阻抗（間隙、導熱膏、不完全的接合）。',
        source: '傅立葉導熱 · 一維平板',
      },
      hEff: {
        label: '有效界面熱傳係數 h_eff',
        reference:
          '壁面對流熱傳係數的量級估算。Q̇ / (L²·ΔT_wall→bulk) — Bi / Nu / j 內部所用之 h 明示為單獨列，可對照對流 BC 宣告的 h。網格側 A_wet 尚未輸出前以 L² 代替。水冷通道 10³〜10⁴ W/(m²·K)、強制風冷 50〜500、沸騰 10⁴〜10⁵。',
        source: 'Newton 冷卻定律・h = q″ / ΔT・Incropera 第 6 章',
      },
    },
  },
  fea: {
    fixtureLoadFaces: '拘束面與載荷面',
    hideFace: '隱藏 {{face}}',
    showFace: '顯示 {{face}}',
    field: '欄位',
    aboutField: '關於此場',
    slice: '切面',
    slicePosition: '切面位置',
    sliceInBody: '{{position}} mm · 於 {{label}}（{{volume}}）',
    sliceInBodyUnlabeled: '{{position}} mm · 於 {{volume}}',
    viewAlongSlice: '沿 {{axis}} 檢視',
    bodies: '零件',
    coloredFaces: '著色面',
    otherFaces: '表面',
    fixturesAndLoads: '拘束與載重',
    thermalBoundaryConditions: '熱邊界條件',
    contactsAndPreloads: '接觸與預載',
    contactsBondsAndPreloads: '接觸、黏合與預載',
    interfacesAndTies: '介面與束縛',
    highlightTarget: '醒目提示 {{detail}}：{{label}}',
    detailsAndHighlightTarget: '詳情並醒目提示 {{detail}}：{{label}}',
    notReported: '未回報',
    sharedMeshInterfaces: '共用網格接合',
    sharedMeshInterfaceHint:
      '以共用網格面或邊相連的物體組合。僅共用邊的接合沒有導熱面積。舊網格需重新產生，才能顯示量測幾何與高亮。',
    edgeOnlyJoin: '僅共用邊',
    pointOnlyJoin: '僅共用點',
    areaUnavailable: '重新產生網格以顯示面積',
    bodyUnassigned: '未指派',
    deformedShape: '變形後外型',
    scale: '變形縮放',
    scaleAuto: '自動 ({{factor}}倍)',
    scaleFactor: '實際尺寸 {{factor}} 倍',
    reactionsTitle: '拘束處反力',
    reactionsHint: '各支撐承受的力 — 為求解結果，非輸入',
    reactionFixture: '拘束處',
    reactionTotal: '合計 (N)',
    reactionAxial: '軸向 (N)',
    reactionShear: '剪力 (N)',
    reactionTension: '拉伸',
    reactionBearing: '承壓',
    reactionNodes: '{{count}} 個節點',
    reactionNoNormal: '無單一面法線 — 僅顯示合計',
    peak: '峰值 {{value}} {{unit}}',
    mode: '模態',
    modeOption: '模態 {{mode}} · {{frequency}}',
    modeNa: '無',
    frequencyHz: '{{frequency}} Hz',
    failedVisualization: '無法載入視覺化',
    legacyArtifact:
      '需要重新執行才能使用線探針與各本體控制。此結果早於體積連接資料。',
    lineProbeUnavailable:
      '此 FEA 結果包含表面 VTU，因此可在模型上放置並檢視探測線，但沒有可供欄位插值的體積樹。請以體積結果成品重新執行以繪製取樣。',
    scrubber: {
      label: '影格',
      play: '播放',
      pause: '暫停',
      slider: '結果影格',
      value: '{{value}} {{unit}}',
      frames: '影格 ({{count}})',
      framesHelp:
        '此軸上共有 {{count}} 個已發布結果影格。播放每四分之一秒前進一格並在兩端循環。拖曳滑桿會載入對應場資料分片，不會重掛載網格。',
      unit: {
        time_s: 's',
        frequency_Hz: 'Hz',
        load_factor: '×',
      },
    },
  },
  // ENG-1545 Block G; 附錄 — 參考文獻與資料可追溯性。
  figures: {
    addChartToWriteup: '將「{{alt}}」加入報告內文',
    axis: {
      distance: '沿線距離 (mm)',
      term: '項',
      flowRate: '流量',
      check: '檢核項目',
      input: '輸入變數',
      iteration: '疊代次數',
      residual: '殘差',
      score: '分數',
      value: '數值',
      varianceShare: '變異占比',
    },
    boundsFitted: '軸範圍依所示資料自動調整。',
    unmeasured_one: '{{count}} 個點未量測，繪為空缺而非零值。',
    unmeasured_other: '{{count}} 個點未量測，繪為空缺而非零值。',
  },
  appendix: {
    references: {
      heading: '引用參考文獻',
      empty:
        '此研究模板沒有適用的預先登記參考。可從結果區段的參考比較選單新增。',
    },
    traceability: {
      heading: '資料可追溯性',
      studyId: '研究 ID',
      generatedAt: '報告產生時間',
      designPoints: '設計點',
      dpCount: '共 {{total}} 個中 {{completed}} 個已完成',
      geometryIds_zero: '幾何 ID',
      geometryIds_one: '幾何 ID',
      geometryIds_other: '幾何 ID ({{count}} 個)',
      meshIds_zero: '網格 ID',
      meshIds_one: '網格 ID',
      meshIds_other: '網格 ID ({{count}} 個)',
      simulationIds_zero: '模擬 ID',
      simulationIds_one: '模擬 ID',
      simulationIds_other: '模擬 ID ({{count}} 個)',
      attemptTag: '(嘗試 {{attempt}})',
    },
  },

  overview: {
    help: {
      completion:
        '確認求解器完成所有要求的載荷步。完成不代表強度、穩定性或力平衡已通過驗證。',
      contact:
        '使用已宣告接觸對的實測張開結果。缺少接觸資料不代表接頭保持閉合。',
      forceBalance:
        '比較最終狀態的外力與支承反力，使用全域 X、Y、Z 分量，共用拘束節點與自由度只計一次。必須載荷資料完整且不平衡力在記錄容許值內才通過。舊結果需以新版後端重跑或重新處理原始輸出。',
      moment:
        '比較相對於質量加權組件重心的外加力矩與支承反力矩。這是全域平衡合力矩，並非任一截面的最大內部彎矩。',
      mesh: '需要至少三個可比較的網格解析度，並比較同一物理量。單次完成的網格不能證明網格獨立性。',
      anchor:
        '比較同一設計點與目前執行的獨立手算結果。請產生計算並補齊缺少的假設；無比較資料不算通過。',
      residuals:
        '依適用收斂條件檢查記錄的求解器殘差。程式結束或單一方程殘差很小，不能單獨證明收斂。',
      guard: '使用此求解器與設定的物理檢查記錄。請開啟相關設計點查看警示原因。',
      mass: '比較入口與出口的積分質量流率。百分比為記錄的相對不平衡量；缺少流率資料則未評估。',
      bounding:
        '求解器將計算值調整至數值允許範圍。此項與收斂及材料強度不同。無記錄不代表未發生調整。',
      yPlus:
        '依目前壁面模型檢查近壁網格解析度。適用於流體模型，不適用於結構 FEA。',
      modes:
        '顯示記錄的固有頻率及已抽取的要求模態數。每個模態有各自的頻率；最低頻率不代表完整頻譜。',
      nonPositive:
        '統計非正特徵值或頻率的數目，不是編號零的模態；也不能辨識所有接近零的正值剛體模態。',
      heat: '比較最終步邊界面積分的進入與離開熱量。容許帶為 max(較大進入／離開量級的 1%, 0.000001 W)。這些積分使用回復的元素溫度梯度，因此差異過大表示邊界梯度的網格解析不足；屬建議性檢查，不是能量守恆失敗，也不是求解器收斂失敗。從節點反力讀出的各面熱流率可能與此積分不同。',
      energyConserved:
        '比較時段內進出固體的能量（∫Q·dt）與儲存熱能變化。未通過表示簿記未閉合——與上方最終步面積分網格檢查是不同的問題。',
      temperatureBounds:
        '最大原理檢查：每個節點溫度必須落在此執行所施加的最低與最高固定溫度（及環境吸熱端）之間。未通過表示有節點離開該物理範圍。',
      stress:
        '節點外插的最大 von Mises 應力，單位 MPa。這是等效應力，不是極限強度；峰值可能受網格與局部奇異點影響。',
      displacement:
        '記錄的最大節點位移大小，單位 mm。需與實際位移限制及小位移假設比較；完成求解不代表極大位移合理。',
      safety:
        '降伏強度除以最大 von Mises 應力。低於 1 不通過，1 至未滿 1.5 需注意，至少 1.5 僅代表此裕度檢查通過。組件摘要可能使用最弱材料，請查看各本體結果。',
      peak: '最大節點外插 von Mises 應力所在的原始網格節點編號，不是元素編號或積分點應力峰值。',
      result:
        '所選設計點的求解器記錄值，單位如畫面所示。缺值不等於零，記錄值本身不代表驗證通過。',
      reaction:
        '全域座標分量的支承反力，僅報告受拘束方向。共用節點可能出現在多個支承列，不能直接加總各列大小作為全域平衡。',
    },
    sweep: {
      thresholds: '降伏安全係數門檻：1 與 1.5',
      summary: '所有設計點統計',
      completedOnly: '分布使用已完成執行的記錄值；缺失與失敗執行仍計入涵蓋數。',
      coverage: '{{n}}/{{total}} 個設計點有記錄',
      distribution: '設計點數值分布',
      designPoint: '設計點 {{label}}',
      minimum: '最小值',
      median: '中位數',
      maximum: '最大值',
      pairedHelp:
        '每組比較同一設計點的獨立計算與求解結果。不同關係式、範圍及單位分開呈現。',
      noMatches:
        '{{total}} 個設計點中有 0 個配對比較。展開下方設計點以檢視或產生計算。',
      matched: '{{n}}/{{total}} 個設計點已配對',
      legend: '○ 預期 · ◆ 求解',
      pairValues: '預期 {{expected}} {{unit}}；求解 {{solved}} {{unit}}',
      errors: '絕對差異：中位 {{median}}%，最大 {{worst}}%（{{n}} 筆記錄）',
      inspect: '檢視或產生設計點比較',
      selectedEvidence: '選定設計點 — 平衡、反力及模態',
      checkCoverage:
        '{{passed}} 通過 · {{flagged}} 須留意 · {{missing}} 未評估',
    },
    evidence: {
      waitingForRun: '此執行完成後即可產生比較。',
      comparisonsReady:
        '{{n}} / {{total}} 項比較已就緒。確認的計算編輯會同步更新此面板。',
      noPrimaryComparison: '手算已可使用，但尚未將主要比較綁定到這些總覽結果。',
      comparisonsNeedInputs:
        '計算已完成，但尚無可配對的比較。請在設計點檢查假設與缺少的輸入。',
      forceBalanceValues: '不平衡力 {{error}} · 容許值 {{tolerance}}',
      momentBalanceTitle: '關於重心的力矩平衡',
      momentBalanceValues: '不平衡 {{error}} · 容許值 {{tolerance}}',
      appliedMoment: '外加',
      reactionMoment: '支承反力',
      cgReference: '重心 (m)：{{xyz}}',
      fixtureMoment: '關於重心的力矩：{{value}}',
      peakStressNode: '最大 von Mises 應力節點',
      peakDisplacementNode: '最大位移節點',
      expectedTitle: '預期值與求解結果',
      expected: '預期值',
      expectedMissing:
        '尚無獨立預期值。目前顯示已記錄的求解值；破折號不代表檢查失敗。',
      safetyBands:
        '降伏安全係數：小於 1 為失敗；1 至小於 1.5 需注意；1.5 以上通過降伏裕度檢查。這不代表整個模型已驗證。',
      generate: '產生比較',
      flaggedCheck: '{{check}} 需要注意。請查看相關設計點的已記錄證據。',
      recorded: '所選設計點的已記錄結果',
      contactSeparation: '接觸分離',
      modesExtracted: '所需模態擷取',
      nonPositiveModes: '非正值模態數',
      bucklingLoadMargin: '挫屈係數高於施加載荷',
      heatBalance: '邊界熱流解析度',
      heatBalanceValues:
        '面積分差異 {{error}} · 容許幅度 {{tolerance}}（流入 {{heatIn}} · 流出 {{heatOut}}）',
      temperatureBounds: '溫度上下限',
      surfaceFluxes: '邊界面熱流率',
      spectrum: '全部已擷取模態',
      mode: '模態 {{n}}',
      modeHelp:
        '此數字為特徵值或頻率非正值的模態數，並非第零模態。此檢查不判別接近零的正頻率。',
      openCalculations: '開啟設計點',
      handCalc: '手算',
      calculationUnavailable: '無法載入手算。上方仍可查看已記錄的求解結果。',
      noComparisons:
        '本瀏覽器工作階段尚未載入此執行的獨立計算。請產生比較，或開啟設計點補齊假設。求解器結果本身不能填入預期值。',
      retry: '重試',
      showLess: '收合比較',
      showAll: '顯示全部 {{count}} 項比較',
      assumptions: '假設與參考資料',
      checkSummary:
        '檢查：{{passed}} 項通過 · {{flagged}} 項需注意 · {{missing}} 項未評估',
      correctionsHelp:
        'OpenFOAM 回報將計算值調整至允許範圍，例如修正負值紊流量。此為數值保護機制，並非工程限值檢查。這與收斂不同：執行可在修正後收斂。缺少記錄不代表未發生修正。',
      meshRequired: '需要三種可比較的網格解析度',
    },
    jump: {
      regionLabel: '跳至總覽的某個區段',
      verdict: '判定',
      trust: '可信度',
      checks: '檢查',
      anchors: '結果與平衡',
      meshIndependence: '網格獨立性',
      results: '結果',
      runHealth: '執行狀態',
      response: '比較',
      sweepResponse: '掃描響應',
      points: '設計點',
      evidence: '證據',
      fields: '場量分佈',
      pareto: 'Pareto',
      sensitivity: '敏感度',
      surrogate: '代理模型',
      context: '背景',
      setup: '設定',
      appendix: '附錄',
      comments: '留言',
    },
    verdict: {
      eyebrow: '判定',
      kind: {
        trustworthy: '可信',
        directional: '僅供參考趨勢',
        unusable: '無可用結果',
        nothingYet: '尚無可回報的結果',
      },
      headline: {
        nothingYet_one: '尚無任何執行產生結果',
        nothingYet_other: '{{count}} 次執行中尚無任何一次產生結果',
        unusable: '無可用結果 — {{total}} 次執行中有 {{failed}} 次未完成',
        trustworthy:
          '{{total}} 次執行中的 {{completed}} 次通過全部 {{ran}} 項檢查',
        flagged:
          '已完成的 {{completed}} 次執行中有 {{flagged}} 次因 {{check}} 被標記',
        qualified: '在 {{check}} 確定之前僅供參考趨勢',
        unexamined: '已完成的 {{completed}} 次執行未執行任何檢查',
      },
      why: {
        unusable: '沒有任何執行完成，因此沒有可讀取的響應。',
        unusableReason: '最常見的失敗：{{reason}}',
        nothingYet: '既沒有完成也沒有失敗，因此目前沒有可判斷的內容。',
        trustworthy: '所有已執行的檢查均通過。記分卡列出了未執行的項目。',
        unexamined:
          '執行已完成，但未回報檢查所需的任何訊號。請將數值視為未經驗證。',
        residuals:
          '未收斂的執行回報的是快照而非解。請將其數值視為分布中的一個樣本，而非答案。',
        guard:
          '求解器已結束，但物理量不封閉。在排除原因之前，請將結果視為趨勢。',
        massBalance:
          '離開計算域的質量與進入的質量不符。壓降與流量取決於質量去了哪裡。',
        energyBalance:
          '本次執行無法交代所給定的功率。穩態解的能量帳目要在解收斂之後才會平衡，因此溫度只是仍在變動之解的快照。',
        bounding:
          '求解器曾調整計算值以符合數值限值。請檢查受影響的物理量與位置。',
        anchor: '求解器與手算的差異超過錨點容許值。兩者之一的設定有誤。',
        yPlus: '未滿足壁面模型範圍，因此近壁力超出了紊流模型的校準範圍。',
        meshIndependence: '結果仍隨網格變動。引用前請再細化一次。',
      },
      actions: {
        reviewFlagged: '檢視被標記的執行',
        seeFailures: '查看失敗群組',
        openWriteup: '開啟報告',
        optimizeInCadMorph: '在 CadMorph 中最佳化',
        optimizeInCadMorphHint:
          '開啟最佳執行的幾何，並附上此研究的目標函數、參數與驅動因子。',
      },
    },
    kpi: {
      best: '最佳',
      bestNoteSpread: '{{dp}} · 離散 ±{{spread}}',
      noValue: '—',
      vsHandCalc: 'vs 手算',
      completed: '已完成',
      runtime: '執行時間',
      runtimeMedian: '中位數 {{median}}',
      stripLabel: '依掃描順序的執行結果',
    },
    setup: {
      cells: '{{cells}} 個網格',
      cellsRange: '{{min}}–{{max}} 個網格',
      expand: '展開設定',
      collapse: '收合設定',
    },
    checks: {
      title: '驗證檢查',
      flaggedOf: '{{total}} 項中有 {{flagged}} 項被標記',
      allPass: '全部 {{total}} 項通過',
      empty: '沒有已完成的執行可供檢查。',
      hidePassing_one: '隱藏 {{count}} 項通過的檢查',
      hidePassing_other: '隱藏 {{count}} 項通過的檢查',
      showPassing_one: '顯示 {{count}} 項通過的檢查',
      showPassing_other: '顯示 {{count}} 項通過的檢查',
      openFlagged: '{{detail}} →',
      label: {
        feaConvergence: '所需載荷步驟已完成',
        feaVerification: '結構驗證',
        feaEquilibrium: '載荷與反力平衡',
        residuals: '殘差收斂',
        guard: '物理檢核',
        massBalance: '質量平衡',
        energyBalance: '能量平衡',
        bounding: '求解器限值修正',
        anchor: '手算錨點',
        yPlus: '壁面 y⁺ 分布',
        meshIndependence: '網格獨立性',
      },
      state: {
        pass: '通過',
        warn: '已標記',
        fail: '失敗',
        notRun: '未執行',
        notApplicable: '不適用',
      },
      detail: {
        ratio: '{{n}}/{{total}}',
        runs_one: '{{count}} 次執行',
        runs_other: '{{count}} 次執行',
        worstPct: '最差 {{pct}}',
        range: '{{min}}–{{max}}',
        none: '無',
        notRun: '未執行',
        notReported: '未回報',
        notApplicable: '不適用於本次執行',
        residualTarget: '{{eq}} 目標 {{target}}，達到 {{achieved}}',
        residualTargetTooltip:
          '目標是此方程式設定的求解器停止門檻。「達到」是最後記錄的殘差。已完成的執行可能因迭代次數用盡而停止，卻未達目標；停止或發散的執行並非已驗證結果。',
        residualNoTargetTooltip:
          '這是最後記錄的殘差。此方程式未報告停止目標，因此無法與門檻比較。停止或發散的執行並非已驗證結果。',
        residualNoTarget: '{{eq}} 達到 {{achieved}} — 線上未帶目標',
        anchorWorst: '{{pct}}',
        anchorCoverage: '已比較 {{n}}/{{total}}',
        gci: 'GCI {{pct}}%',
      },
    },
    anchors: {
      title: '結果與平衡',
      subtitle: '僅列偏差 — 計算過程在各執行的手算中',
      vsHand: 'vs 手算',
      openRun: '手算 →',
      against: '偏差是相對於 {{anchor}}。',
      empty: '此範本沒有適用的手算錨點。',
    },
    response: {
      title: '響應',
      quantity: '量',
      sweepHeading: '掃描響應：',
      vs: 'vs {{axis}}',
      pointsOf: '{{total}} 點中的 {{n}} 點',
      empty: '各執行之間沒有變化的輸入 — 單一點沒有響應曲線。',
      extremes: '極值',
      min: '最小',
      max: '最大',
      missing_one: '缺少 {{count}} 點 — {{dps}} 未完成。',
      missing_other: '缺少 {{count}} 點 — {{dps}} 未完成。',
      unplaced_one: '{{count}} 次執行沒有掃描輸入的值,未繪出 — {{dps}}。',
      unplaced_other: '{{count}} 次執行沒有掃描輸入的值,未繪出 — {{dps}}。',
      unreported_one: '{{count}} 次執行已完成但未回報此輸出 — {{dps}}。',
      unreported_other: '{{count}} 次執行已完成但未回報此輸出 — {{dps}}。',
      whyFailed: '失敗原因 →',
    },
    runHealth: {
      completion: '{{n}} / {{total}} 次執行已完成',
      medianRuntime: '執行時間中位數',
      p95Runtime: '第 95 百分位執行時間',
      convergence: '已回報達到收斂',
      convergenceHelp: '求解器記錄的收斂狀態，與執行完成及物理驗證分開。',
      notConverged: '{{n}} 次已完成的執行回報尚未收斂。',
      convergenceMissing: '{{n}} 次已完成的執行未回報收斂狀態。',
      title: '執行狀態',
      progressLabel: '已結束執行的比例',
      oneCause_one: '失敗只有一個原因。',
      oneCause_other:
        '全部 {{count}} 次失敗都是同一原因。修正後可找回掃描中的 {{count}} 個點。',
      manyCauses: '{{count}} 次失敗中有 {{groups}} 種不同原因。',
      openFailures: '開啟失敗群組 →',
    },
    points: {
      title: '設計點',
      fullTable: '含所有輸入的完整表格 →',
      run: '執行',
      status: '狀態',
      deltaVsBest: '與最佳的 Δ',
      checks: '檢查',
      checkStateHelp:
        '未執行表示適用的驗證沒有產生紀錄。不適用表示此求解器不使用該檢查。',
      checkNotRun: '未執行 — 無驗證紀錄',
      notSet: '未設定或未回報',
      runtime: '執行時間',
      open: '開啟 →',
      openError: '錯誤 →',
      best: '最佳',
    },
    fields: {
      title: '場量分佈 · {{dp}}',
      titleBest: '場量分佈 · {{dp}}（最佳執行）',
      openViewer: '開啟檢視器 →',
    },
  },
  feaVerification: {
    axisLabel: '檢查',
    title: '結構自洽性檢查',
    hint: '評分只採用已記錄的 FEA 證據；缺少工程限值時顯示為無資料。',
    unavailable: '無資料',
    notEnoughAxes: '有記錄證據的結構檢查少於三項，因此尚無足夠資料繪製雷達圖。',
    criterionLabel: '評分標準',
    evidenceLabel: '證據',
    scoreLabel: '分數',
    safetyFactor: '安全係數 {{value}}',
    distribution: '已評分軸',
    worst: '最低',
    median: '中位',
    best: '最高',
    evidence: {
      converged: '已收斂',
      diverged: '發散',
      closed: '所有接觸面保持閉合',
      opened: '接觸面已張開',
    },
    axes: {
      solverCompletion: '求解器完成度',
      reactionEquilibrium: '反力平衡',
      yieldMargin: '降伏裕度',
      ultimateMargin: '極限強度裕度',
      displacementPlausibility: '位移合理性',
      contactIntegrity: '接觸完整性',
    },
    criteria: {
      solverCompletion: '二元判定',
      reactionEquilibrium: '±1% 平衡',
      yieldMargin: '安全係數 1.0 → 1.5',
      ultimateMargin: '安全係數 1.0 → 1.5',
      displacementPlausibility: '需要位移上限',
      contactIntegrity: '二元判定',
    },
    tooltips: {
      solverCompletion: '求解器記錄收斂時為 100%；記錄發散時為 0%。',
      reactionEquilibrium:
        '比較施加載荷合力與支承反力；兩者皆有記錄後才顯示於雷達圖。',
      yieldMargin:
        '降伏安全係數 1.0 時為 0%，至 1.5 線性增加為 100%；低於 1.0 仍為 0%。',
      ultimateMargin:
        '極限安全係數 1.0 時為 0%，至 1.5 線性增加為 100%；低於 1.0 仍為 0%。',
      displacementPlausibility:
        '比較最大位移與使用者指定的容許位移；設定上限後才顯示。',
      contactIntegrity:
        '所有已量測接觸面保持閉合時為 100%；任一接觸面張開時為 0%。',
    },
  },
} as const;
